<template>
  <a-modal
    title="商户进件"
    :visible="visible"
    :width="800"
    :footer="null"
    :maskClosable="false"
    @cancel="handleClose">
    <a-spin :spinning="loading">
      <!-- 渠道开通状态总览：微信/支付宝独立跟踪 -->
      <a-row :gutter="12" class="channel-cards">
        <a-col :span="12">
          <a-card size="small" title="微信渠道" :bordered="true">
            <a-tag :color="statusType">{{ wxStatusText }}</a-tag>
            <div v-if="statusInfo.jeepayMchNo && statusInfo.applyStatus === '3'" class="tip-text">
              商户号：{{ statusInfo.jeepayMchNo }}
            </div>
            <div v-else-if="!statusInfo.applyStatus" class="tip-text">未提交在线进件，可在下方进件向导中提交微信特约商户进件</div>
          </a-card>
        </a-col>
        <a-col :span="12">
          <a-card size="small" title="支付宝渠道" :bordered="true">
            <!-- 已授权：当面付签约状态机（3已开通/1审核中/2待商家确认/0|4签约表单） -->
            <template v-if="aliInfo.applyStatus === '1'">
              <template v-if="aliInfo.faceStatus === '3'">
                <a-tag color="green">已开通</a-tag>
                <div class="tip-text">商户号：{{ aliInfo.jeepayMchNo }}</div>
                <div class="tip-text">支付宝收款已开通（授权 + 当面付均已生效），付款码/扫码均可收款</div>
                <div style="margin-top: 6px">
                  <a-button size="small" :loading="aliStarting" @click="startAliAuth">重新授权</a-button>
                </div>
              </template>
              <template v-else-if="aliInfo.faceStatus === '1'">
                <a-tag color="blue">当面付审核中</a-tag>
                <div class="tip-text">商户号：{{ aliInfo.jeepayMchNo }}</div>
                <div class="tip-text">支付宝审核一般数分钟至12小时，本页自动更新；超1个工作日未变化可联系支付宝客服 4007585858</div>
                <div style="margin-top: 6px">
                  <a-button size="small" :loading="aliStarting" @click="startAliAuth">重新授权</a-button>
                </div>
              </template>
              <template v-else-if="aliInfo.faceStatus === '2'">
                <a-tag color="orange">待商家确认</a-tag>
                <img v-if="aliFaceQr" :src="'data:image/png;base64,' + aliFaceQr" alt="当面付确认二维码" class="sign-qr" />
                <div class="tip-text">审核已通过，请商家用<strong>支付宝App</strong>扫码确认开通"当面付"（也可在支付宝App-消息-消息盒子待办中确认）</div>
                <div class="tip-text">商家确认后本页自动更新为已开通</div>
                <div style="margin-top: 4px">
                  <a-button size="small" @click="openAliFaceConfirm">复制确认链接发给商家</a-button>
                </div>
              </template>
              <template v-else>
                <a-tag v-if="aliInfo.faceStatus === '4'" color="red">签约驳回</a-tag>
                <a-tag v-else>已授权·待开通当面付</a-tag>
                <div v-if="aliInfo.faceStatus === '4'" class="tip-text" style="color: #f5222d">驳回原因：{{ aliInfo.faceRejectReason || '请联系平台客服' }}</div>
                <div v-else class="tip-text">支付宝收款需开通"当面付"产品，资料已自动复用，仅补充经营类目即可提交</div>
                <div style="margin-top: 6px">
                  <a-select
                    v-model="faceForm.mccCode"
                    placeholder="请选择经营类目"
                    style="width: 100%"
                    show-search
                    :filter-option="filterIndustryOption">
                    <a-select-opt-group v-for="g in aliMccOptions" :key="g.label" :label="g.label">
                      <a-select-option v-for="opt in g.options" :key="opt.value" :value="opt.value">{{ opt.label }}</a-select-option>
                    </a-select-opt-group>
                  </a-select>
                  <a-cascader
                    v-model="faceForm.areaPath"
                    :options="bizAreaOptions"
                    placeholder="店铺所在省/市/区（选填）"
                    style="margin-top: 8px; width: 100%" />
                  <a-input v-model="faceForm.detailAddress" placeholder="店铺详细地址（选填，留空自动复用微信进件地址）" maxLength="128" style="margin-top: 8px" />
                  <a-input v-model="faceForm.aliAccount" placeholder="商家支付宝账号（选填，留空自动获取）" maxLength="64" style="margin-top: 8px" />
                  <a-input v-model="faceForm.licenseMobile" placeholder="执照法人手机号（授权支付宝与执照法人非同一人时必填，法人将收到短信授权）" maxLength="11" style="margin-top: 8px" />
                  <a-button type="primary" size="small" style="margin-top: 8px" :loading="faceSubmitting" @click="submitAliFaceSign">提交当面付签约</a-button>
                </div>
              </template>
            </template>
            <!-- 待授权：授权二维码（手机浏览器扫）+ 链接按钮 + 轮询 -->
            <template v-else-if="aliInfo.applyStatus === '0'">
              <a-tag color="orange">待授权</a-tag>
              <img v-if="aliQr" :src="'data:image/png;base64,' + aliQr" alt="支付宝授权二维码" class="sign-qr" />
              <div class="tip-text">请用<strong>手机浏览器</strong>扫码（请勿用支付宝"扫一扫"），或点击按钮在本机浏览器打开授权页</div>
              <div class="tip-text">请用<strong>经营者本人的支付宝</strong>确认授权（授权谁的支付宝，收款就结算到谁的账户）；完成后本页自动更新</div>
              <div style="margin-top: 4px">
                <a-button type="primary" size="small" @click="openAliAuth">前往支付宝授权</a-button>
                <a-button size="small" style="margin-left: 8px" :loading="aliStarting" @click="startAliAuth">重新发起授权</a-button>
              </div>
            </template>
            <!-- 未开通：扫码授权（零资料，即时生效） -->
            <template v-else>
              <a-tag>未开通</a-tag>
              <div class="tip-text">已有支付宝账号即可开通：扫码授权、无需资料、即时生效，收款直接结算到您的支付宝账户。</div>
              <a-button type="primary" size="small" style="margin-top: 4px" :loading="aliStarting" @click="startAliAuth">扫码授权开通支付宝收款</a-button>
            </template>
            <!-- 手动回填（兜底：运营平台手动配置后填入） -->
            <div v-if="aliEditing" style="margin-top: 8px">
              <a-input-search
                v-model="aliMchNo"
                placeholder="请输入平台运营提供的支付宝商户号"
                :maxLength="64"
                enter-button="保存"
                :loading="aliSaving"
                @search="saveAliMerchant" />
              <a-input
                v-model="aliAppId"
                placeholder="应用ID（平台运营提供，选填）"
                :maxLength="128"
                style="margin-top: 8px" />
              <a-input
                v-model="aliAppSecret"
                placeholder="应用密钥（平台运营提供，选填）"
                :maxLength="128"
                style="margin-top: 8px" />
              <a-button size="small" style="margin-top: 8px" @click="aliEditing = false">取消</a-button>
            </div>
          </a-card>
        </a-col>
      </a-row>

      <!-- 微信进件状态卡片（已有申请单时） -->
      <template v-if="statusInfo.applyStatus">
        <a-alert class="status-alert" :type="statusType" show-icon>
          <template slot="message">
            <span>当前状态：{{ statusText }}</span>
            <a-button v-if="statusInfo.applyStatus === '1' || statusInfo.applyStatus === '2'"
                      size="small" style="margin-left: 12px" @click="load">刷新进度</a-button>
          </template>
          <template slot="description">
            <div v-if="statusInfo.applyStateMsg">{{ statusInfo.applyStateMsg }}</div>
            <!-- 待账户验证：超管微信扫码完成确认 -->
            <div v-if="statusInfo.applyStatus === '1' && statusInfo.signUrl" style="margin-top: 8px">
              <img v-if="signQr" :src="'data:image/png;base64,' + signQr" alt="账户验证二维码" class="sign-qr" />
              <div class="tip-text">请使用超级管理员微信扫码完成账户验证，完成后点击"刷新进度"。</div>
            </div>
            <!-- 待签约：超管扫码或打开签约链接完成开户意愿确认 -->
            <div v-if="statusInfo.applyStatus === '2'" style="margin-top: 8px">
              <img v-if="signQr" :src="'data:image/png;base64,' + signQr" alt="签约二维码" class="sign-qr" />
              <a-button type="primary" icon="link" :disabled="!statusInfo.signUrl"
                        @click="openSignUrl">打开签约/开户链接</a-button>
              <div class="tip-text">请使用超级管理员微信扫码完成签约（也可点击按钮打开链接），完成后点击"刷新进度"。</div>
            </div>
            <!-- 驳回原因 -->
            <div v-if="statusInfo.applyStatus === '4' && statusInfo.auditRemark" class="reject-remark">
              驳回原因：{{ statusInfo.auditRemark }}
            </div>
            <!-- 成功信息 -->
            <div v-if="statusInfo.applyStatus === '3'" style="margin-top: 8px">
              <div>Jeepay商户号：{{ statusInfo.jeepayMchNo }}</div>
              <div>微信特约商户号：{{ statusInfo.subMchid }}</div>
              <div class="tip-text">收款商户号已自动回填到"支付商户"列表，本租户订单即可在线收款。</div>
            </div>
          </template>
        </a-alert>
        <!-- 查看已提交进件资料（折叠） -->
        <a-collapse v-if="['0', '1', '2', '3', '4'].indexOf(statusInfo.applyStatus) > -1" style="margin-top: 8px">
          <a-collapse-panel header="查看进件资料" key="profile">
            <div v-for="row in profileRows" :key="row.label" class="summary-row">
              <span class="summary-label">{{ row.label }}</span>
              <span class="summary-value">{{ row.value }}</span>
            </div>
          </a-collapse-panel>
        </a-collapse>
      </template>

      <!-- 进件表单（无申请 / 草稿 / 驳回重提）：5 步向导 -->
      <div v-if="formEditable" style="margin-top: 8px">
        <a-divider v-if="statusInfo.applyStatus" orientation="left">修改后重新提交</a-divider>
        <a-steps :current="step - 1" size="small" class="wizard-steps" @change="onStepChange">
          <a-step v-for="t in stepTitles" :key="t" :title="t" />
        </a-steps>

        <a-form>
          <!-- 步骤1：营业执照（上传后自动 OCR 识别带动填表） -->
          <template v-if="step === 1">
            <div class="tip-text ocr-tip">上传执照照片后自动识别商户名称、信用代码与法人，请核对识别结果</div>
            <a-form-item label="执照照片" v-bind="formItemLayout">
              <a-upload
                list-type="picture-card"
                class="apply-uploader"
                accept=".jpg,.jpeg,.bmp,.png"
                :file-list="fileList.licenseCopy"
                :customRequest="(opt) => doUpload(opt, 'licenseCopy')"
                :before-upload="beforeUpload"
                @preview="handlePreview"
                :remove="(f) => handleRemove(f, 'licenseCopy')">
                <div v-if="!fileList.licenseCopy.length">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">上传</div>
                </div>
              </a-upload>
            </a-form-item>
            <a-form-item label="主体类型" v-bind="formItemLayout">
              <a-select v-model="form.subjectType" placeholder="请选择主体类型" @change="handleSubjectChange">
                <a-select-option value="2500">企业</a-select-option>
                <a-select-option value="4">个体工商户</a-select-option>
              </a-select>
              <div class="tip-text">已参加微信泛行业优惠费率活动，商户交易手续费按 0.38% 结算（未参加活动为 0.6%），提交后自动生效</div>
            </a-form-item>
            <a-form-item label="商户名称" v-bind="formItemLayout">
              <a-input v-model="form.mchName" placeholder="营业执照上的商户全称" :maxLength="128" />
            </a-form-item>
            <a-form-item label="注册号/统一社会信用代码" v-bind="formItemLayout">
              <a-input v-model="form.licenseNumber" placeholder="统一社会信用代码" :maxLength="32" />
            </a-form-item>
            <a-form-item label="法定代表人" v-bind="formItemLayout">
              <a-input v-model="form.licenseLegalPerson" placeholder="营业执照法定代表人姓名" :maxLength="64" />
            </a-form-item>
          </template>

          <!-- 步骤2：主体联系信息 -->
          <template v-if="step === 2">
            <a-form-item label="商户简称" v-bind="formItemLayout">
              <a-input v-model="form.mchShortName" placeholder="收银台展示的简称" :maxLength="64" />
            </a-form-item>
            <a-form-item label="联系人" v-bind="formItemLayout">
              <a-input v-model="form.contactName" placeholder="已按执照法人自动填写" :maxLength="64" />
              <div class="tip-text">联系人仅用于平台内部联系；微信进件的超级管理员默认为经营者本人（按经营者身份证实名），联系手机用于接收微信验证短信</div>
            </a-form-item>
            <a-form-item label="联系手机" v-bind="formItemLayout">
              <a-input v-model="form.contactMobile" placeholder="用于接收微信审核通知" :maxLength="20" />
            </a-form-item>
            <a-form-item label="客服电话" v-bind="formItemLayout">
              <a-input v-model="form.servicePhone" placeholder="客服电话" :maxLength="20" />
            </a-form-item>
          </template>

          <!-- 步骤3：经营者/法人身份证（上传后自动 OCR 识别） -->
          <template v-if="step === 3">
            <div class="tip-text ocr-tip">上传身份证照片后自动识别姓名、号码与有效期，请核对识别结果</div>
            <a-form-item label="身份证人像面" v-bind="formItemLayout">
              <a-upload
                list-type="picture-card"
                class="apply-uploader"
                accept=".jpg,.jpeg,.bmp,.png"
                :file-list="fileList.idCardCopy"
                :customRequest="(opt) => doUpload(opt, 'idCardCopy')"
                :before-upload="beforeUpload"
                @preview="handlePreview"
                :remove="(f) => handleRemove(f, 'idCardCopy')">
                <div v-if="!fileList.idCardCopy.length">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">上传</div>
                </div>
              </a-upload>
            </a-form-item>
            <a-form-item label="身份证国徽面" v-bind="formItemLayout">
              <a-upload
                list-type="picture-card"
                class="apply-uploader"
                accept=".jpg,.jpeg,.bmp,.png"
                :file-list="fileList.idCardNational"
                :customRequest="(opt) => doUpload(opt, 'idCardNational')"
                :before-upload="beforeUpload"
                @preview="handlePreview"
                :remove="(f) => handleRemove(f, 'idCardNational')">
                <div v-if="!fileList.idCardNational.length">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">上传</div>
                </div>
              </a-upload>
            </a-form-item>
            <a-form-item label="身份证姓名" v-bind="formItemLayout">
              <a-input v-model="form.idCardName" placeholder="身份证姓名" :maxLength="64" />
            </a-form-item>
            <a-form-item label="身份证号码" v-bind="formItemLayout">
              <a-input v-model="form.idCardNumber" placeholder="身份证号码" :maxLength="18" />
            </a-form-item>
            <a-form-item label="身份证有效期-起" v-bind="formItemLayout">
              <a-input v-model="form.idCardPeriodBegin" placeholder="如 2020-01-01" :maxLength="16" />
            </a-form-item>
            <a-form-item label="身份证有效期-止" v-bind="formItemLayout">
              <a-input v-model="form.idCardPeriodEnd" placeholder="如 2030-01-01；长期证件请填：长期" :maxLength="16" />
            </a-form-item>

            <!-- 企业主体：受益所有人（持股≥25%自然人，微信必填） -->
            <template v-if="form.subjectType === '2500'">
              <a-divider orientation="left">受益所有人（企业必填）</a-divider>
              <div class="tip-text" style="margin-bottom: 8px">
                持股≥25%的自然人均需填写；若法定代表人本人就是唯一持股人，点击"复用法人资料"一键填入即可
              </div>
              <div v-for="(ubo, idx) in form.uboList" :key="idx" class="ubo-card">
                <div class="ubo-head">
                  <span>受益所有人 {{ idx + 1 }}</span>
                  <a-button v-if="form.uboList.length > 1" size="small" type="danger" icon="delete"
                            @click="removeUbo(idx)">删除</a-button>
                </div>
                <a-form-item label="姓名" v-bind="formItemLayout">
                  <a-input v-model="ubo.name" placeholder="受益所有人身份证上的姓名" :maxLength="64" />
                </a-form-item>
                <a-form-item label="身份证号" v-bind="formItemLayout">
                  <a-input v-model="ubo.idNumber" placeholder="18位身份证号码" :maxLength="18" />
                </a-form-item>
                <a-form-item label="身份证人像面" v-bind="formItemLayout">
                  <a-upload
                    list-type="picture-card"
                    class="apply-uploader"
                    accept=".jpg,.jpeg,.bmp,.png"
                    :file-list="ubo.flCopy"
                    :customRequest="(opt) => doUploadUbo(opt, ubo, 'idCardCopy')"
                    :before-upload="beforeUpload"
                    @preview="handlePreview"
                    :remove="() => handleRemoveUbo(ubo, 'idCardCopy')">
                    <div v-if="!ubo.flCopy.length">
                      <a-icon type="plus" />
                      <div class="ant-upload-text">上传</div>
                    </div>
                  </a-upload>
                </a-form-item>
                <a-form-item label="身份证国徽面" v-bind="formItemLayout">
                  <a-upload
                    list-type="picture-card"
                    class="apply-uploader"
                    accept=".jpg,.jpeg,.bmp,.png"
                    :file-list="ubo.flNational"
                    :customRequest="(opt) => doUploadUbo(opt, ubo, 'idCardNational')"
                    :before-upload="beforeUpload"
                    @preview="handlePreview"
                    :remove="() => handleRemoveUbo(ubo, 'idCardNational')">
                    <div v-if="!ubo.flNational.length">
                      <a-icon type="plus" />
                      <div class="ant-upload-text">上传</div>
                    </div>
                  </a-upload>
                </a-form-item>
                <a-form-item label="身份证有效期-起" v-bind="formItemLayout">
                  <a-input v-model="ubo.periodBegin" placeholder="如 2020-01-01" :maxLength="16" />
                </a-form-item>
                <a-form-item label="身份证有效期-止" v-bind="formItemLayout">
                  <a-input v-model="ubo.periodEnd" placeholder="如 2030-01-01；长期证件请填：长期" :maxLength="16" />
                </a-form-item>
              </div>
              <a-button type="dashed" block icon="plus" style="margin-bottom: 8px" @click="addUbo">添加受益所有人</a-button>
              <a-button icon="copy" @click="copyLegalAsUbo">复用法人资料（法人100%持股时）</a-button>
            </template>
          </template>

          <!-- 步骤4：经营信息（所属行业+线下场所，微信进件必填） -->
          <template v-if="step === 4">
            <a-form-item label="所属行业" v-bind="formItemLayout">
              <a-select v-model="form.qualificationType" placeholder="请选择所属行业" show-search
                        :filter-option="filterIndustryOption" @change="onIndustryChange">
                <a-select-opt-group v-for="g in industryGroups" :key="g.group" :label="g.group">
                  <a-select-option v-for="ind in g.items" :key="ind.name" :value="ind.name">{{ ind.name }}</a-select-option>
                </a-select-opt-group>
              </a-select>
              <div class="tip-text">{{ industryHint || '请按营业执照经营范围选择最贴近的行业类目' }}</div>
            </a-form-item>
            <a-form-item label="线下场所名称" v-bind="formItemLayout">
              <a-input v-model="form.bizStoreName" placeholder="门店招牌名称，与门头照上名称一致" :maxLength="128" />
            </a-form-item>
            <a-form-item label="线下场所省市区" v-bind="formItemLayout">
              <a-cascader :value="bizAreaPath" :options="bizAreaOptions" placeholder="请选择营业执照所在省/市/区" @change="onBizAreaChange" />
              <div class="tip-text">请选择营业执照对应的省市区</div>
            </a-form-item>
            <a-form-item label="线下场所地址" v-bind="formItemLayout">
              <a-input v-model="form.bizStoreAddress" placeholder="营业执照地址去掉省市区后的部分" :maxLength="512" />
            </a-form-item>
            <a-form-item label="门头照片" v-bind="formItemLayout">
              <a-upload
                list-type="picture-card"
                class="apply-uploader"
                accept=".jpg,.jpeg,.bmp,.png"
                multiple
                :file-list="fileList.storeEntrancePic"
                :customRequest="(opt) => doUploadMulti(opt, 'storeEntrancePic')"
                :before-upload="beforeUpload"
                @preview="handlePreview"
                :remove="(f) => removeMulti(f, 'storeEntrancePic')">
                <div v-if="fileList.storeEntrancePic.length < 5">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">上传</div>
                </div>
              </a-upload>
              <div class="tip-text">正面拍摄、清晰完整、图片不得有遮挡；门店招牌清晰、名称文字可辨识、门框完整且店面显示在营（1-5张）</div>
            </a-form-item>
            <a-form-item label="内部照片" v-bind="formItemLayout">
              <a-upload
                list-type="picture-card"
                class="apply-uploader"
                accept=".jpg,.jpeg,.bmp,.png"
                multiple
                :file-list="fileList.indoorPic"
                :customRequest="(opt) => doUploadMulti(opt, 'indoorPic')"
                :before-upload="beforeUpload"
                @preview="handlePreview"
                :remove="(f) => removeMulti(f, 'indoorPic')">
                <div v-if="fileList.indoorPic.length < 5">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">上传</div>
                </div>
              </a-upload>
              <div class="tip-text">能展示内部环境并辨识所经营的业务/销售商品（1-5张）；停车场等开阔场地可上传内部环境照片</div>
            </a-form-item>

            <!-- 行业资质：仅需资质行业显示（无需资质行业整块不渲染，传了微信报错） -->
            <template v-if="industryNeedPics">
              <a-divider orientation="left">行业资质（必填）</a-divider>
              <a-form-item label="资质照片" v-bind="formItemLayout">
                <a-upload
                  list-type="picture-card"
                  class="apply-uploader"
                  accept=".jpg,.jpeg,.bmp,.png"
                  multiple
                  :file-list="fileList.qualificationPics"
                  :customRequest="(opt) => doUploadMulti(opt, 'qualificationPics')"
                  :before-upload="beforeUpload"
                  @preview="handlePreview"
                  :remove="(f) => removeMulti(f, 'qualificationPics')">
                  <div v-if="fileList.qualificationPics.length < 5">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">上传</div>
                  </div>
                </a-upload>
                <div class="tip-text">{{ industryHint }}</div>
              </a-form-item>
            </template>
          </template>

          <!-- 步骤5：结算银行账户 -->
          <template v-if="step === 5">
            <a-form-item label="账户类型" v-bind="formItemLayout">
              <a-select v-model="form.bankAccountType" placeholder="请选择账户类型"
                        :disabled="form.subjectType === '2500'" @change="onAccountTypeChange">
                <a-select-option value="CORPORATE">对公账户</a-select-option>
                <a-select-option value="PERSONAL" :disabled="form.subjectType === '2500'">经营者个人银行卡</a-select-option>
              </a-select>
              <div v-if="form.subjectType === '2500'" class="tip-text">企业主体必须使用对公账户</div>
            </a-form-item>
            <a-form-item label="开户名称" v-bind="formItemLayout">
              <a-input v-model="form.accountName" placeholder="对公账户为商户名称，个人卡为经营者姓名" :maxLength="128" />
              <div class="tip-text">已按账户类型自动预填：对公填商户名称，个人卡填经营者身份证姓名</div>
            </a-form-item>
            <a-form-item label="开户银行" v-bind="formItemLayout">
              <a-select v-model="form.accountBank" placeholder="请选择开户银行（微信官方银行列表）" show-search
                        :filter-option="filterBankOption" @change="onBankChange">
                <a-select-option v-for="b in wxBankOptions" :key="b" :value="b">{{ b }}</a-select-option>
              </a-select>
              <div class="tip-text">微信官方银行列表；选择列表内银行无需填写支行信息</div>
            </a-form-item>
            <a-form-item v-if="isDirectBank" label="开户行全称" v-bind="formItemLayout">
              <a-input :value="form.accountBank" disabled />
              <div class="tip-text">{{ form.accountBank }}为微信直连银行，无需填写支行，自动以总行名称提交</div>
            </a-form-item>
            <a-form-item v-else label="开户行全称" v-bind="formItemLayout">
              <a-select v-model="form.bankName" show-search allow-clear
                        placeholder="输入支行名称模糊搜索，如：大丰 / 海淀支行"
                        :filter-option="false" :default-active-first-option="false"
                        :loading="branchSearching" :options="branchOptions"
                        @search="onBranchSearch" @change="onBranchSelect" />
              <div class="tip-text">请先从上方选择"其他银行"，再从联行号库搜索支行并选择，自动填写省市编码</div>
            </a-form-item>
            <a-form-item label="开户银行所在地" v-bind="formItemLayout">
              <a-cascader :value="bankAreaPath" :options="areaOptions" placeholder="请选择开户银行所在省/市" @change="onAreaChange" />
              <div class="tip-text">选择后自动填写微信省市编码；从支行列表选择支行时也会自动带出</div>
            </a-form-item>
            <a-form-item label="银行账号" v-bind="formItemLayout">
              <a-input v-model="form.accountNumber" placeholder="银行账号" :maxLength="32" />
            </a-form-item>
            <a-form-item label="银行卡识别" v-bind="formItemLayout">
              <a-upload :show-upload-list="false" accept=".jpg,.jpeg,.png"
                        :customRequest="onBankCardOcr" :before-upload="beforeUpload">
                <a-button icon="camera">上传银行卡照片自动识别</a-button>
              </a-upload>
              <div class="tip-text">自动识别银行账号与开户银行，识别结果可手动修正</div>
            </a-form-item>
          </template>

          <!-- 步骤6：信息确认 + 渠道勾选 -->
          <template v-if="step === 6">
            <div class="summary-box">
              <div v-for="row in summaryRows" :key="row.label" class="summary-row">
                <span class="summary-label">{{ row.label }}</span>
                <span class="summary-value">{{ row.value }}</span>
              </div>
              <div class="tip-text" style="margin-top: 8px">请核对以上信息并选择要开通的收款渠道，确认无误后提交</div>
            </div>
            <a-form-item label="开通渠道" v-bind="formItemLayout" style="margin-top: 8px">
              <a-checkbox-group v-model="channels">
                <a-checkbox value="WX">微信支付（提交资料审核，1-2天）</a-checkbox>
                <a-checkbox value="ALI">支付宝（扫码授权，无需资料，即时生效）</a-checkbox>
              </a-checkbox-group>
            </a-form-item>
          </template>
        </a-form>

        <div style="text-align: right; margin-top: 8px">
          <a-button @click="handleClose">关闭</a-button>
          <a-button v-if="step > 1" style="margin-left: 8px" @click="prevStep">上一步</a-button>
          <a-button v-if="step < 6" type="primary" style="margin-left: 8px" @click="nextStep">下一步</a-button>
          <a-button v-else type="primary" style="margin-left: 8px" :loading="submitting" @click="handleSubmit">
            {{ submitBtnText }}
          </a-button>
        </div>
      </div>
    </a-spin>
    <!-- 证件大图预览 -->
    <a-modal :visible="previewVisible" :footer="null" :width="720" :zIndex="1200"
             title="证件照片" @cancel="previewVisible = false">
      <img :src="previewImage" style="width: 100%" alt="证件照片" />
    </a-modal>
  </a-modal>
</template>

<script>
import { getMchApplyCurrent, getMchApplySignQrcode, submitMchApply, uploadMchApplyImage, ocrMchApply, getSupplierProfile, getMchApplyBankBranches, getMchApplyImage, getMchApplyIndustries, getMchApplyImages, deleteMchApplyImage, saveMchApplyAliMerchant, submitAliFaceSign as submitAliFaceSignApi, getAliFaceStatus } from '@/api/plugin/orderReceive'
import { tenantProfilePrefill } from '@/api/plugin/dining'
import { pcaa } from 'area-data'

const EMPTY_FORM = {
  mchName: '', mchShortName: '', subjectType: undefined, contactName: '', contactMobile: '', servicePhone: '',
  licenseCopy: '', licenseNumber: '', licenseLegalPerson: '',
  idCardCopy: '', idCardNational: '', idCardName: '', idCardNumber: '',
  idCardPeriodBegin: '', idCardPeriodEnd: '',
  bankAccountType: undefined, accountName: '', accountBank: '', bankName: '', bankAddressCode: '', accountNumber: '',
  qualificationType: undefined, bizStoreName: '', bizAddressCode: '', bizStoreAddress: '',
  storeEntrancePic: [], indoorPic: [],
  uboList: [], qualificationPics: []
}

const STATUS_TEXT = { '0': '草稿（未提交）', '1': '微信审核中', '2': '待签约/开户验证', '3': '进件成功', '4': '已驳回' }
const STATUS_TYPE = { '0': 'info', '1': 'warning', '2': 'warning', '3': 'success', '4': 'error' }
const SUBJECT_TEXT = { '2500': '企业', '4': '个体工商户' }
const ACCOUNT_TEXT = { CORPORATE: '对公账户', PERSONAL: '经营者个人银行卡' }

// 本地草稿 key（纯本地缓存，正式提交成功后清除）
const DRAFT_KEY = 'mch_apply_draft'
// 上传字段 → 后端图片类型 type（上传即存储+OCR，返回 storageKey）
const UPLOAD_TYPE = {
  licenseCopy: 'license', idCardCopy: 'idcard_front', idCardNational: 'idcard_back',
  storeEntrancePic: 'entrance', indoorPic: 'indoor', qualificationPics: 'qualification'
}
// 受益所有人证件类型（与经营者证件分开存储，多图不覆盖）
const UBO_UPLOAD_TYPE = { idCardCopy: 'ubo_front', idCardNational: 'ubo_back' }
// 各 cardType 可回填的表单字段
const OCR_FIELDS = {
  license: ['mchName', 'licenseNumber', 'licenseLegalPerson'],
  idcard_front: ['idCardName', 'idCardNumber'],
  idcard_back: ['idCardPeriodBegin', 'idCardPeriodEnd'],
  bankcard: ['accountNumber', 'accountBank']
}
// 表单字段 → 中文名（OCR 提示精准列出已填写字段）
const FIELD_LABELS = {
  mchName: '商户名称', licenseNumber: '注册号/信用代码', licenseLegalPerson: '法定代表人',
  idCardName: '身份证姓名', idCardNumber: '身份证号码',
  idCardPeriodBegin: '身份证有效期起', idCardPeriodEnd: '身份证有效期止',
  accountNumber: '银行账号', accountBank: '开户银行', contactName: '联系人'
}
// 受益所有人 OCR 映射：[OCR返回字段, 受益人字段]（idcard_front/back 回填到受益所有人对象）
const UBO_OCR_MAP = {
  idcard_front: [['idCardName', 'name'], ['idCardNumber', 'idNumber']],
  idcard_back: [['idCardPeriodBegin', 'periodBegin'], ['idCardPeriodEnd', 'periodEnd']]
}
const UBO_FIELD_LABELS = { name: '姓名', idNumber: '身份证号', periodBegin: '有效期起', periodEnd: '有效期止' }
// 微信官方直连银行列表（无需填支行，account_bank 直传总行名；来源于微信服务商后台银行列表）
const WX_DIRECT_BANKS = ['中国银行', '工商银行', '农业银行', '建设银行', '交通银行', '招商银行', '邮政储蓄银行', '民生银行',
  '中信银行', '光大银行', '华夏银行', '平安银行', '广发银行', '浦发银行', '兴业银行', '北京银行', '上海银行',
  '宁波银行', '南京银行', '长沙银行']
// 省市行政区划（微信认可码集，与小程序端/联行号库同源；直辖市市级码=省级码，如 北京 110000）
const REGION = [
  { code: '110000', name: '北京市', cities: [['110000', '北京市']] },
  { code: '120000', name: '天津市', cities: [['120000', '天津市']] },
  { code: '130000', name: '河北省', cities: [['130100', '石家庄市'], ['130200', '唐山市'], ['130300', '秦皇岛市'], ['130400', '邯郸市'], ['130500', '邢台市'], ['130600', '保定市'], ['130700', '张家口市'], ['130800', '承德市'], ['130900', '沧州市'], ['131000', '廊坊市'], ['131100', '衡水市']] },
  { code: '140000', name: '山西省', cities: [['140100', '太原市'], ['140200', '大同市'], ['140300', '阳泉市'], ['140400', '长治市'], ['140500', '晋城市'], ['140600', '朔州市'], ['140700', '晋中市'], ['140800', '运城市'], ['140900', '忻州市'], ['141000', '临汾市'], ['141100', '吕梁市']] },
  { code: '150000', name: '内蒙古自治区', cities: [['150100', '呼和浩特市'], ['150200', '包头市'], ['150300', '乌海市'], ['150400', '赤峰市'], ['150500', '通辽市'], ['150600', '鄂尔多斯市'], ['150700', '呼伦贝尔市'], ['150800', '巴彦淖尔市'], ['150900', '乌兰察布市'], ['152200', '兴安盟'], ['152500', '锡林郭勒盟'], ['152900', '阿拉善盟']] },
  { code: '210000', name: '辽宁省', cities: [['210100', '沈阳市'], ['210200', '大连市'], ['210300', '鞍山市'], ['210400', '抚顺市'], ['210500', '本溪市'], ['210600', '丹东市'], ['210700', '锦州市'], ['210800', '营口市'], ['210900', '阜新市'], ['211000', '辽阳市'], ['211100', '盘锦市'], ['211200', '铁岭市'], ['211300', '朝阳市'], ['211400', '葫芦岛市']] },
  { code: '220000', name: '吉林省', cities: [['220100', '长春市'], ['220200', '吉林市'], ['220300', '四平市'], ['220400', '辽源市'], ['220500', '通化市'], ['220600', '白山市'], ['220700', '松原市'], ['220800', '白城市'], ['222400', '延边朝鲜族自治州']] },
  { code: '230000', name: '黑龙江省', cities: [['230100', '哈尔滨市'], ['230200', '齐齐哈尔市'], ['230300', '鸡西市'], ['230400', '鹤岗市'], ['230500', '双鸭山市'], ['230600', '大庆市'], ['230700', '伊春市'], ['230800', '佳木斯市'], ['230900', '七台河市'], ['231000', '牡丹江市'], ['231100', '黑河市'], ['231200', '绥化市'], ['232700', '大兴安岭地区']] },
  { code: '310000', name: '上海市', cities: [['310000', '上海市']] },
  { code: '320000', name: '江苏省', cities: [['320100', '南京市'], ['320200', '无锡市'], ['320300', '徐州市'], ['320400', '常州市'], ['320500', '苏州市'], ['320600', '南通市'], ['320700', '连云港市'], ['320800', '淮安市'], ['320900', '盐城市'], ['321000', '扬州市'], ['321100', '镇江市'], ['321200', '泰州市'], ['321300', '宿迁市']] },
  { code: '330000', name: '浙江省', cities: [['330100', '杭州市'], ['330200', '宁波市'], ['330300', '温州市'], ['330400', '嘉兴市'], ['330500', '湖州市'], ['330600', '绍兴市'], ['330700', '金华市'], ['330800', '衢州市'], ['330900', '舟山市'], ['331000', '台州市'], ['331100', '丽水市']] },
  { code: '340000', name: '安徽省', cities: [['340100', '合肥市'], ['340200', '芜湖市'], ['340300', '蚌埠市'], ['340400', '淮南市'], ['340500', '马鞍山市'], ['340600', '淮北市'], ['340700', '铜陵市'], ['340800', '安庆市'], ['341000', '黄山市'], ['341100', '滁州市'], ['341200', '阜阳市'], ['341300', '宿州市'], ['341500', '六安市'], ['341600', '亳州市'], ['341700', '池州市'], ['341800', '宣城市']] },
  { code: '350000', name: '福建省', cities: [['350100', '福州市'], ['350200', '厦门市'], ['350300', '莆田市'], ['350400', '三明市'], ['350500', '泉州市'], ['350600', '漳州市'], ['350700', '南平市'], ['350800', '龙岩市'], ['350900', '宁德市']] },
  { code: '360000', name: '江西省', cities: [['360100', '南昌市'], ['360200', '景德镇市'], ['360300', '萍乡市'], ['360400', '九江市'], ['360500', '新余市'], ['360600', '鹰潭市'], ['360700', '赣州市'], ['360800', '吉安市'], ['360900', '宜春市'], ['361000', '抚州市'], ['361100', '上饶市']] },
  { code: '370000', name: '山东省', cities: [['370100', '济南市'], ['370200', '青岛市'], ['370300', '淄博市'], ['370400', '枣庄市'], ['370500', '东营市'], ['370600', '烟台市'], ['370700', '潍坊市'], ['370800', '济宁市'], ['370900', '泰安市'], ['371000', '威海市'], ['371100', '日照市'], ['371300', '临沂市'], ['371400', '德州市'], ['371500', '聊城市'], ['371600', '滨州市'], ['371700', '菏泽市']] },
  { code: '410000', name: '河南省', cities: [['410100', '郑州市'], ['410200', '开封市'], ['410300', '洛阳市'], ['410400', '平顶山市'], ['410500', '安阳市'], ['410600', '鹤壁市'], ['410700', '新乡市'], ['410800', '焦作市'], ['410900', '濮阳市'], ['411000', '许昌市'], ['411100', '漯河市'], ['411200', '三门峡市'], ['411300', '南阳市'], ['411400', '商丘市'], ['411500', '信阳市'], ['411600', '周口市'], ['411700', '驻马店市']] },
  { code: '420000', name: '湖北省', cities: [['420100', '武汉市'], ['420200', '黄石市'], ['420300', '十堰市'], ['420500', '宜昌市'], ['420600', '襄阳市'], ['420700', '鄂州市'], ['420800', '荆门市'], ['420900', '孝感市'], ['421000', '荆州市'], ['421100', '黄冈市'], ['421200', '咸宁市'], ['421300', '随州市'], ['422800', '恩施土家族苗族自治州']] },
  { code: '430000', name: '湖南省', cities: [['430100', '长沙市'], ['430200', '株洲市'], ['430300', '湘潭市'], ['430400', '衡阳市'], ['430500', '邵阳市'], ['430600', '岳阳市'], ['430700', '常德市'], ['430800', '张家界市'], ['430900', '益阳市'], ['431000', '郴州市'], ['431100', '永州市'], ['431200', '怀化市'], ['431300', '娄底市'], ['433100', '湘西土家族苗族自治州']] },
  { code: '440000', name: '广东省', cities: [['440100', '广州市'], ['440200', '韶关市'], ['440300', '深圳市'], ['440400', '珠海市'], ['440500', '汕头市'], ['440600', '佛山市'], ['440700', '江门市'], ['440800', '湛江市'], ['440900', '茂名市'], ['441200', '肇庆市'], ['441300', '惠州市'], ['441400', '梅州市'], ['441500', '汕尾市'], ['441600', '河源市'], ['441700', '阳江市'], ['441800', '清远市'], ['441900', '东莞市'], ['442000', '中山市'], ['445100', '潮州市'], ['445200', '揭阳市'], ['445300', '云浮市']] },
  { code: '450000', name: '广西壮族自治区', cities: [['450100', '南宁市'], ['450200', '柳州市'], ['450300', '桂林市'], ['450400', '梧州市'], ['450500', '北海市'], ['450600', '防城港市'], ['450700', '钦州市'], ['450800', '贵港市'], ['450900', '玉林市'], ['451000', '百色市'], ['451100', '贺州市'], ['451200', '河池市'], ['451300', '来宾市'], ['451400', '崇左市']] },
  { code: '460000', name: '海南省', cities: [['460100', '海口市'], ['460200', '三亚市'], ['460300', '三沙市'], ['460400', '儋州市']] },
  { code: '500000', name: '重庆市', cities: [['500000', '重庆市']] },
  { code: '510000', name: '四川省', cities: [['510100', '成都市'], ['510300', '自贡市'], ['510400', '攀枝花市'], ['510500', '泸州市'], ['510600', '德阳市'], ['510700', '绵阳市'], ['510800', '广元市'], ['510900', '遂宁市'], ['511000', '内江市'], ['511100', '乐山市'], ['511300', '南充市'], ['511400', '眉山市'], ['511500', '宜宾市'], ['511600', '广安市'], ['511700', '达州市'], ['511800', '雅安市'], ['511900', '巴中市'], ['512000', '资阳市'], ['513200', '阿坝藏族羌族自治州'], ['513300', '甘孜藏族自治州'], ['513400', '凉山彝族自治州']] },
  { code: '520000', name: '贵州省', cities: [['520100', '贵阳市'], ['520200', '六盘水市'], ['520300', '遵义市'], ['520400', '安顺市'], ['520500', '毕节市'], ['520600', '铜仁市'], ['522300', '黔西南布依族苗族自治州'], ['522600', '黔东南苗族侗族自治州'], ['522700', '黔南布依族苗族自治州']] },
  { code: '530000', name: '云南省', cities: [['530100', '昆明市'], ['530300', '曲靖市'], ['530400', '玉溪市'], ['530500', '保山市'], ['530600', '昭通市'], ['530700', '丽江市'], ['530800', '普洱市'], ['530900', '临沧市'], ['532300', '楚雄彝族自治州'], ['532500', '红河哈尼族彝族自治州'], ['532600', '文山壮族苗族自治州'], ['532800', '西双版纳傣族自治州'], ['532900', '大理白族自治州'], ['533100', '德宏傣族景颇族自治州'], ['533300', '怒江傈僳族自治州'], ['533400', '迪庆藏族自治州']] },
  { code: '540000', name: '西藏自治区', cities: [['540100', '拉萨市'], ['540200', '日喀则市'], ['540300', '昌都市'], ['540400', '林芝市'], ['540500', '山南市'], ['540600', '那曲市'], ['542500', '阿里地区']] },
  { code: '610000', name: '陕西省', cities: [['610100', '西安市'], ['610200', '铜川市'], ['610300', '宝鸡市'], ['610400', '咸阳市'], ['610500', '渭南市'], ['610600', '延安市'], ['610700', '汉中市'], ['610800', '榆林市'], ['610900', '安康市'], ['611000', '商洛市']] },
  { code: '620000', name: '甘肃省', cities: [['620100', '兰州市'], ['620200', '嘉峪关市'], ['620300', '金昌市'], ['620400', '白银市'], ['620500', '天水市'], ['620600', '武威市'], ['620700', '张掖市'], ['620800', '平凉市'], ['620900', '酒泉市'], ['621000', '庆阳市'], ['621100', '定西市'], ['621200', '陇南市'], ['622900', '临夏回族自治州'], ['623000', '甘南藏族自治州']] },
  { code: '630000', name: '青海省', cities: [['630100', '西宁市'], ['630200', '海东市'], ['632200', '海北藏族自治州'], ['632300', '黄南藏族自治州'], ['632500', '海南藏族自治州'], ['632600', '果洛藏族自治州'], ['632700', '玉树藏族自治州'], ['632800', '海西蒙古族藏族自治州']] },
  { code: '640000', name: '宁夏回族自治区', cities: [['640100', '银川市'], ['640200', '石嘴山市'], ['640300', '吴忠市'], ['640400', '固原市'], ['640500', '中卫市']] },
  { code: '650000', name: '新疆维吾尔自治区', cities: [['650100', '乌鲁木齐市'], ['650200', '克拉玛依市'], ['650400', '吐鲁番市'], ['650500', '哈密市'], ['652300', '昌吉回族自治州'], ['652700', '博尔塔拉蒙古自治州'], ['652800', '巴音郭楞蒙古自治州'], ['652900', '阿克苏地区'], ['653000', '克孜勒苏柯尔克孜自治州'], ['653100', '喀什地区'], ['653200', '和田地区'], ['654000', '伊犁哈萨克自治州'], ['654200', '塔城地区'], ['654300', '阿勒泰地区']] }
]
// 省市二级级联选项（value=6位微信行政区划码，与联行号库 bank_address_code 同集）
const AREA_OPTIONS = REGION.map((p) => ({
  value: p.code,
  label: p.name,
  children: p.cities.map((c) => ({ value: c[0], label: c[1] }))
}))
// 线下场所省市区三级级联选项（area-data pcaa，末级=区县6位码，即微信 biz_address_code）
const BIZ_AREA_OPTIONS = (() => {
  const provinces = pcaa['86'] || {}
  const tree = []
  Object.keys(provinces).forEach((pCode) => {
    const pNode = { value: pCode, label: provinces[pCode], children: [] }
    const cities = pcaa[pCode] || {}
    Object.keys(cities).forEach((cCode) => {
      const cNode = { value: cCode, label: cities[cCode], children: [] }
      const districts = pcaa[cCode] || {}
      Object.keys(districts).forEach((dCode) => {
        cNode.children.push({ value: dCode, label: districts[dCode] })
      })
      pNode.children.push(cNode)
    })
    tree.push(pNode)
  })
  return tree
})()
// 区县级编码 → 省市区名称回显（线性建一次索引）
const BIZ_AREA_NAME = (() => {
  const map = {}
  BIZ_AREA_OPTIONS.forEach((p) => p.children.forEach((c) => c.children.forEach((d) => {
    map[d.value] = p.label + ' ' + c.label + ' ' + d.label
  })))
  return map
})()
// 支付宝当面付经营类目（官方 02khjv 商家经营类目编码，两级格式：一级code_二级code，按一级行业分组）
const ALI_MCC_OPTIONS = [
  { label: '餐饮', options: [
    { value: 'A0001_B0001', label: '中式正餐' }, { value: 'A0001_B0002', label: '西式正餐' },
    { value: 'A0001_B0003', label: '日韩/东南亚菜' }, { value: 'A0001_B0004', label: '中式快餐' },
    { value: 'A0001_B0005', label: '西式快餐' }, { value: 'A0001_B0006', label: '小吃/熟食' },
    { value: 'A0001_B0009', label: '饮品/甜品' }, { value: 'A0001_B0010', label: '烘焙糕点' },
    { value: 'A0001_B0011', label: '酒吧/清吧' }, { value: 'A0001_B0012', label: '咖啡馆/茶馆' },
    { value: 'A0001_B0199', label: '火锅' }
  ] },
  { label: '零售批发', options: [
    { value: 'A0002_B0013', label: '杂货店/百货' }, { value: 'A0002_B0014', label: '连锁便利店' },
    { value: 'A0002_B0021', label: '水果店' }, { value: 'A0002_B0022', label: '茶叶' },
    { value: 'A0002_B0023', label: '酒类' }, { value: 'A0002_B0025', label: '营养品/保健品' },
    { value: 'A0002_B0026', label: '服饰鞋包' }, { value: 'A0002_B0027', label: '美妆个护' },
    { value: 'A0002_B0028', label: '黄金珠宝/钟表' }, { value: 'A0002_B0029', label: '眼镜店' },
    { value: 'A0002_B0030', label: '3C数码/家用电器' }, { value: 'A0002_B0031', label: '图文音像/工美乐器' },
    { value: 'A0002_B0032', label: '母婴用品/儿童玩具' }, { value: 'A0002_B0033', label: '宠物/宠物用品' },
    { value: 'A0002_B0034', label: '户外运动器材' }, { value: 'A0002_B0035', label: '五金建材' },
    { value: 'A0002_B0036', label: '鲜花/绿植' }, { value: 'A0002_B0201', label: '食品零售' },
    { value: 'A0002_B0202', label: '蔬菜/肉蛋/水产' }, { value: 'A0002_B0203', label: '办公用品' }
  ] },
  { label: '商业生活服务', options: [
    { value: 'A0003_B0044', label: '美发/美容/美甲' }, { value: 'A0003_B0045', label: '洗浴/保健养生' },
    { value: 'A0003_B0046', label: '家政/清洁服务' }, { value: 'A0003_B0047', label: '维修服务' },
    { value: 'A0003_B0048', label: '建筑装饰/装修' }, { value: 'A0003_B0050', label: '宠物医院/宠物服务' },
    { value: 'A0003_B0052', label: '无人值守自助服务' }
  ] }
]
// 每步必填校验：[字段, 提示]（步骤1 执照上传+OCR 带动填表，步骤2 联系信息）
const STEP_CHECKS = {
  1: [['licenseCopy', '请上传营业执照照片'], ['subjectType', '请选择主体类型'], ['mchName', '请填写商户名称'],
      ['licenseNumber', '请填写注册号/统一社会信用代码'], ['licenseLegalPerson', '请填写法定代表人']],
  2: [['mchShortName', '请填写商户简称'], ['contactMobile', '请填写联系手机'], ['servicePhone', '请填写客服电话']],
  3: [['idCardCopy', '请上传身份证人像面'], ['idCardNational', '请上传身份证国徽面'], ['idCardName', '请填写身份证姓名'],
      ['idCardNumber', '请填写身份证号码'], ['idCardPeriodBegin', '请填写身份证有效期-起'], ['idCardPeriodEnd', '请填写身份证有效期-止']],
  4: [['qualificationType', '请选择所属行业'], ['bizStoreName', '请填写线下场所名称'], ['bizAddressCode', '请选择线下场所所在省市区'],
      ['bizStoreAddress', '请填写线下场所地址'], ['storeEntrancePic', '请上传线下场所门头照片'], ['indoorPic', '请上传线下场所内部照片']],
  5: [['bankAccountType', '请选择账户类型'], ['accountName', '请填写开户名称'], ['accountBank', '请选择开户银行'],
      ['bankAddressCode', '请选择开户银行所在地'], ['accountNumber', '请填写银行账号']]
}
// 资料/汇总展示字段
const PROFILE_LABELS = [
  ['subjectType', '主体类型'], ['mchName', '商户名称'], ['mchShortName', '商户简称'],
  ['contactName', '联系人'], ['contactMobile', '联系手机'], ['servicePhone', '客服电话'],
  ['licenseNumber', '统一社会信用代码'], ['licenseLegalPerson', '法定代表人'],
  ['idCardName', '身份证姓名'], ['idCardNumber', '身份证号码'],
  ['idCardPeriodBegin', '身份证有效期-起'], ['idCardPeriodEnd', '身份证有效期-止'],
  ['qualificationType', '所属行业'], ['bizStoreName', '线下场所名称'], ['bizAddressCode', '线下场所省市区'],
  ['bizStoreAddress', '线下场所地址'],
  ['bankAccountType', '账户类型'], ['accountName', '开户名称'], ['accountBank', '开户银行'],
  ['bankName', '开户行全称'], ['bankAddressCode', '开户银行所在地'], ['accountNumber', '银行账号']
]

export default {
  name: 'MchApplyModal',
  props: {
    visible: { type: Boolean, default: false }
  },
  data() {
    return {
      formItemLayout: { labelCol: { span: 6 }, wrapperCol: { span: 15 } },
      loading: false,
      submitting: false,
      statusInfo: {},
      aliInfo: {},
      aliMchNo: '',
      aliAppId: '',
      aliAppSecret: '',
      aliEditing: false,
      aliSaving: false,
      aliStarting: false,
      aliQr: '',
      aliPollTimer: null,
      faceForm: { mccCode: undefined, areaPath: [], detailAddress: '', aliAccount: '', licenseMobile: '' },
      aliMccOptions: ALI_MCC_OPTIONS,
      aliFaceQr: '',
      faceSubmitting: false,
      facePollTimer: null,
      channels: ['WX', 'ALI'],
      signQr: '',
      form: Object.assign({}, EMPTY_FORM, { uboList: [], qualificationPics: [] }),
      fileList: { licenseCopy: [], idCardCopy: [], idCardNational: [], qualificationPics: [], storeEntrancePic: [], indoorPic: [] },
      stepTitles: ['营业执照', '主体信息', '经营者身份证', '经营信息', '结算账户', '信息确认'],
      step: 1,
      maxStep: 1,
      previewVisible: false,
      previewImage: '',
      branchOptions: [],
      branchSearching: false,
      industries: [],
      bizAreaOptions: BIZ_AREA_OPTIONS
    }
  },
  computed: {
    formEditable() {
      return !this.statusInfo.applyStatus || ['0', '4'].indexOf(this.statusInfo.applyStatus) > -1
    },
    // 提交按钮文案：随步骤6渠道勾选动态变化
    submitBtnText() {
      const hasWx = this.channels.indexOf('WX') > -1
      const hasAli = this.channels.indexOf('ALI') > -1
      if (!hasWx && hasAli) { return '发起支付宝授权' }
      if (hasWx && hasAli) { return this.statusInfo.applyStatus === '4' ? '重新提交（微信审核+支付宝授权）' : '提交开通（微信审核+支付宝扫码授权）' }
      return this.statusInfo.applyStatus === '4' ? '重新提交' : '提交微信审核'
    },
    // 下拉选项：直连银行 + 其他银行（联行号库搜支行）；历史值不在列表时追加，避免回显空白
    wxBankOptions() {
      const options = WX_DIRECT_BANKS.concat(['其他银行'])
      const cur = (this.form.accountBank || '').trim()
      if (cur && options.indexOf(cur) === -1) {
        options.unshift(cur)
      }
      return options
    },
    // 是否微信直连银行（免填支行）
    isDirectBank() {
      return WX_DIRECT_BANKS.indexOf((this.form.accountBank || '').trim()) > -1
    },
    // 省市选项（cascader）
    areaOptions() {
      return AREA_OPTIONS
    },
    // 省市编码 → cascader 回显路径（未命中返回空，如旧数据码不在微信码集）
    bankAreaPath() {
      const code = (this.form.bankAddressCode || '').trim()
      if (!/^\d{6}$/.test(code)) return []
      for (const p of AREA_OPTIONS) {
        for (const c of p.children) {
          if (c.value === code) return [p.value, c.value]
        }
      }
      return []
    },
    statusText() {
      return STATUS_TEXT[this.statusInfo.applyStatus] || this.statusInfo.applyStatus
    },
    statusType() {
      return STATUS_TYPE[this.statusInfo.applyStatus] || 'info'
    },
    // 渠道卡片：微信渠道状态文案
    wxStatusText() {
      return STATUS_TEXT[this.statusInfo.applyStatus] || '未开通'
    },
    // 所属行业下拉：按大类分组（数据源 /mch-apply/industries）
    industryGroups() {
      const groups = []
      const idx = {}
      this.industries.forEach((ind) => {
        if (!idx[ind.group]) {
          idx[ind.group] = { group: ind.group, items: [] }
          groups.push(idx[ind.group])
        }
        idx[ind.group].items.push(ind)
      })
      return groups
    },
    // 当前所选行业的资质提示
    industryHint() {
      const cur = (this.form.qualificationType || '').trim()
      if (!cur) { return '' }
      const hit = this.industries.find((ind) => ind.name === cur)
      return hit ? hit.hint : ''
    },
    // 当前所选行业是否需上传资质图片（无需资质行业界面整块不显示）
    industryNeedPics() {
      const cur = (this.form.qualificationType || '').trim()
      if (!cur) { return false }
      const hit = this.industries.find((ind) => ind.name === cur)
      return hit ? !!hit.needPics : false
    },
    // 线下场所区县编码 → cascader 回显路径
    bizAreaPath() {
      const code = (this.form.bizAddressCode || '').trim()
      if (!/^\d{6}$/.test(code)) return []
      for (const p of this.bizAreaOptions) {
        for (const c of p.children) {
          for (const d of c.children) {
            if (d.value === code) return [p.value, c.value, d.value]
          }
        }
      }
      return []
    },
    // 步骤5：当前表单汇总
    summaryRows() {
      const rows = PROFILE_LABELS.map(([key, label]) => ({ label: label, value: this.displayValue(this.form, key) }))
      if (this.form.subjectType === '2500') {
        const names = (this.form.uboList || []).map((u) => (u.name || '').trim()).filter(Boolean)
        rows.push({ label: '受益所有人', value: names.length ? names.join('、') + '（共' + names.length + '人）' : '—' })
      }
      if (this.industryNeedPics && (this.form.qualificationPics || []).length) {
        rows.push({ label: '行业资质', value: '已上传' + this.form.qualificationPics.length + '张' })
      }
      rows.push({ label: '门头照片', value: '已上传' + (this.form.storeEntrancePic || []).length + '张' })
      rows.push({ label: '内部照片', value: '已上传' + (this.form.indoorPic || []).length + '张' })
      return rows
    },
    // 状态卡片：已提交进件资料
    profileRows() {
      const rows = PROFILE_LABELS.map(([key, label]) => ({ label: label, value: this.displayValue(this.statusInfo, key) }))
      const ubos = this.statusInfo.uboList || []
      if (ubos.length) {
        const names = ubos.map((u) => u.name).filter(Boolean)
        rows.push({ label: '受益所有人', value: names.length ? names.join('、') + '（共' + names.length + '人）' : '—' })
      }
      const pics = this.statusInfo.qualificationPics || []
      if (pics.length) {
        rows.push({ label: '行业资质', value: '已上传' + pics.length + '张' })
      }
      const entrance = this.statusInfo.storeEntrancePic || []
      const indoor = this.statusInfo.indoorPic || []
      if (entrance.length || indoor.length) {
        rows.push({ label: '场所照片', value: '门头' + entrance.length + '张 / 内部' + indoor.length + '张' })
      }
      return rows
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.load()
      }
    }
  },
  // 组件销毁兜底清理轮询定时器，避免内存泄漏
  beforeDestroy() {
    if (this.aliPollTimer) {
      clearInterval(this.aliPollTimer)
      this.aliPollTimer = null
    }
    if (this.facePollTimer) {
      clearInterval(this.facePollTimer)
      this.facePollTimer = null
    }
  },
  methods: {
    displayValue(source, key) {
      const val = source ? source[key] : ''
      if (key === 'subjectType') return SUBJECT_TEXT[val] || val || '—'
      if (key === 'bankAccountType') return ACCOUNT_TEXT[val] || val || '—'
      if (key === 'bizAddressCode') return BIZ_AREA_NAME[('' + (val || '')).trim()] || val || '—'
      return (val === undefined || val === null || val === '') ? '—' : val
    },
    load() {
      this.loading = true
      // 行业目录（下拉数据源，加载一次）
      if (!this.industries.length) {
        getMchApplyIndustries().then((res) => {
          if (res.code === 200 && Array.isArray(res.data)) {
            this.industries = res.data
          }
        }).catch(() => { /* 行业目录加载失败不阻断，可重进再试 */ })
      }
      getMchApplyCurrent().then((res) => {
        if (res.code === 200) {
          const data = res.data || {}
          this.statusInfo = data.wx || {}
          this.aliInfo = data.ali || {}
          // 待账户验证/待签约：拉签约二维码供超管微信扫码（失败静默，不影响链接按钮）
          this.loadSignQr(this.statusInfo)
          // 支付宝待授权：拉授权二维码并轮询授权结果
          this.syncAliQr()
          // 支付宝已授权：当面付签约状态机 + 回显已存签约资料
          this.syncFaceState()
          this.initFaceForm()
          if (this.formEditable) {
            this.step = 1
            this.maxStep = 1
            const draft = this.readDraft()
            if (draft) {
              // 本地草稿优先（含已上传 mediaId 与步骤位置），中途退出不丢数据、停留在退出时的步骤
              this.form = Object.assign({}, EMPTY_FORM, { uboList: [], qualificationPics: [] }, draft.form)
              this.normalizeArrays()
              this.syncFileList(this.form)
              this.step = draft.step || 1
              this.maxStep = draft.maxStep || 6
            } else if (this.statusInfo.applyStatus === '4' || this.statusInfo.applyStatus === '0') {
              // 驳回/草稿：回填已保存资料便于修改重提（图片 storageKey 已存库，服务器可读直接复用）
              this.form = Object.assign({}, EMPTY_FORM, { uboList: [], qualificationPics: [] }, this.pickForm(this.statusInfo))
              this.normalizeArrays()
              this.syncFileList(this.form)
              // 暂存图回显：重传过的新图优先于库内旧值，空字段用 OCR 结果回填
              this.restoreStagedImages()
            } else {
              this.resetForm()
              this.prefillFromProfile()
              // 无本地草稿时从服务器暂存图恢复（提交失败/中途退出不丢图片与识别结果）
              this.restoreStagedImages()
            }
            this.ensureUboRow()
            // 主体档案预填（系统配置→主体资料，add 或未提交态；仅填空字段，已填不动）
            this.prefillFromTenantProfile()
          }
        } else {
          this.$message.warning(res.message || '查询进件状态失败')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // ===== 本地草稿（localStorage，纯客户端缓存） =====
    readDraft() {
      try {
        const raw = localStorage.getItem(DRAFT_KEY)
        if (!raw) return null
        const draft = JSON.parse(raw)
        return (draft && typeof draft === 'object') ? draft : null
      } catch (e) {
        return null
      }
    },
    saveDraft() {
      try {
        localStorage.setItem(DRAFT_KEY, JSON.stringify({ step: this.step, maxStep: this.maxStep, form: this.form }))
      } catch (e) {
        // 存储失败（隐私模式/已满）不阻断向导
      }
    },
    clearDraft() {
      try {
        localStorage.removeItem(DRAFT_KEY)
      } catch (e) { /* 忽略 */ }
    },
    // 企业资料预填：仅填空字段
    prefillFromProfile() {
      getSupplierProfile().then((res) => {
        if (res.code === 200 && res.data && res.data.partners && res.data.partners.length) {
          const p = res.data.partners[0]
          const mapping = { supplier: ['mchName'], taxNum: ['licenseNumber'], bankName: ['accountBank', 'bankName'],
            accountNumber: ['accountNumber'], contacts: ['contactName'],
            phoneNum: ['contactMobile', 'servicePhone'], telephone: ['contactMobile', 'servicePhone'] }
          Object.keys(mapping).forEach((srcKey) => {
            mapping[srcKey].forEach((field) => {
              if (!this.form[field] && p[srcKey]) {
                this.form[field] = p[srcKey]
              }
            })
          })
          // 档案银行名规范化为微信直连列表（"中国工商银行"→"工商银行"），匹配不到视为其他银行
          if (this.form.accountBank) {
            const matched = this.matchWxBank(this.form.accountBank)
            this.form.accountBank = matched || '其他银行'
            if (this.form.accountBank === '其他银行') { this.form.bankName = '' }
          }
        }
      }).catch(() => { /* 预填失败不阻断 */ })
    },
    // 主体档案预填（系统配置→主体资料维护，GET /tenant-profile/prefill）：
    // 仅填空字段（已填不动）；图片字段档案侧为数组，进件表单单图字段取[0]；接口失败静默 console.warn
    prefillFromTenantProfile() {
      tenantProfilePrefill().then((res) => {
        if (res.code !== 200 || !res.data || !this.visible || !this.formEditable) { return }
        const d = res.data
        // 文本字段直填（仅空值）
        const textMap = ['mchName', 'contactName', 'contactMobile', 'licenseNumber', 'licenseLegalPerson',
          'idCardName', 'idCardNumber', 'idCardPeriodBegin', 'idCardPeriodEnd']
        textMap.forEach((k) => {
          if (!this.form[k] && d[k]) { this.form[k] = d[k] }
        })
        // 主体类型联动（账户类型/受益人为空时才联动，不覆盖已填）
        if (!this.form.subjectType && (d.subjectType === '2500' || d.subjectType === '4')) {
          this.form.subjectType = d.subjectType
          if (!this.form.bankAccountType) {
            this.handleSubjectChange(d.subjectType)
          } else {
            this.ensureUboRow()
          }
        }
        // 单图字段：档案数组取第一张
        let imgFilled = false
        const singleMap = ['licenseCopy', 'idCardCopy', 'idCardNational']
        singleMap.forEach((k) => {
          if (!this.form[k] && Array.isArray(d[k]) && d[k].length) {
            this.form[k] = d[k][0]
            imgFilled = true
          }
        })
        // 经营许可证（多图，上限5张与表单一致）
        if ((!this.form.qualificationPics || !this.form.qualificationPics.length) && Array.isArray(d.qualificationPics) && d.qualificationPics.length) {
          this.form.qualificationPics = d.qualificationPics.slice(0, 5)
          imgFilled = true
        }
        if (imgFilled) { this.syncFileList(this.form) }
      }).catch((err) => { console.warn('主体档案预填失败（不阻断进件）', err) })
    },
    pickForm(data) {
      const picked = {}
      Object.keys(EMPTY_FORM).forEach((key) => {
        if (data[key]) {
          picked[key] = data[key]
        }
      })
      if (!picked.subjectType) {
        picked.subjectType = data.subjectType
      }
      if (!picked.bankAccountType) {
        picked.bankAccountType = data.bankAccountType
      }
      return picked
    },
    // uboList/qualificationPics/storeEntrancePic/indoorPic 兜底为独立数组（防浅拷贝共享引用）
    normalizeArrays() {
      if (!Array.isArray(this.form.uboList)) { this.form.uboList = [] }
      if (!Array.isArray(this.form.qualificationPics)) { this.form.qualificationPics = [] }
      if (!Array.isArray(this.form.storeEntrancePic)) { this.form.storeEntrancePic = [] }
      if (!Array.isArray(this.form.indoorPic)) { this.form.indoorPic = [] }
      this.form.uboList.forEach((u) => {
        if (!Array.isArray(u.flCopy)) { u.flCopy = [] }
        if (!Array.isArray(u.flNational)) { u.flNational = [] }
      })
    },
    syncFileList(data) {
      const map = { licenseCopy: '执照照片', idCardCopy: '身份证人像面', idCardNational: '身份证国徽面' }
      Object.keys(map).forEach((field) => {
        this.fileList[field] = data[field]
          ? [{ uid: field, name: map[field], status: 'done', thumbUrl: this.placeholderImage(map[field]), mediaId: data[field] }]
          : []
        if (data[field]) {
          this.loadRealThumb(this.fileList[field][0], data[field])
        }
      })
      // 受益所有人证件占位（已上传 mediaId 复用）
      ;(this.form.uboList || []).forEach((u) => {
        u.flCopy = u.idCardCopy
          ? [{ uid: 'ubo_copy', name: '身份证人像面', status: 'done', thumbUrl: this.placeholderImage('受益人证件'), mediaId: u.idCardCopy }]
          : []
        u.flNational = u.idCardNational
          ? [{ uid: 'ubo_national', name: '身份证国徽面', status: 'done', thumbUrl: this.placeholderImage('受益人证件'), mediaId: u.idCardNational }]
          : []
        if (u.idCardCopy) { this.loadRealThumb(u.flCopy[0], u.idCardCopy) }
        if (u.idCardNational) { this.loadRealThumb(u.flNational[0], u.idCardNational) }
      })
      // 行业资质/门头照/内部照占位（多图 mediaId 复用）
      const multiMap = { qualificationPics: '资质照片', storeEntrancePic: '门头照片', indoorPic: '内部照片' }
      Object.keys(multiMap).forEach((field) => {
        this.fileList[field] = (this.form[field] || []).map((id, i) => ({
          uid: 'ph_' + id, name: multiMap[field] + (i + 1), status: 'done', thumbUrl: this.placeholderImage(multiMap[field]), mediaId: id
        }))
        this.fileList[field].forEach((f) => { this.loadRealThumb(f, f.mediaId) })
      })
    },
    // 异步加载本地副本真实图替换占位图（404/失败保留占位，不阻断）
    loadRealThumb(entry, mediaId) {
      if (!entry || !mediaId) { return }
      getMchApplyImage(mediaId).then((resp) => {
        if (resp && resp.size > 0 && this.visible) {
          entry.thumbUrl = URL.createObjectURL(resp)
        }
      }).catch(() => {})
    },
    // 服务器暂存图回显：单图字段取最新暂存图（比重提库内值新），多图字段去重合并；
    // 空文本字段用暂存 OCR 结果回填（仅填空不覆盖，不弹提示）
    restoreStagedImages() {
      getMchApplyImages().then((res) => {
        if (res.code !== 200 || !Array.isArray(res.data) || !this.visible || !this.formEditable) { return }
        const byType = {}
        res.data.forEach((img) => {
          if (img && img.storageKey) {
            (byType[img.imageType] = byType[img.imageType] || []).push(img)
          }
        })
        const singleMap = { license: 'licenseCopy', idcard_front: 'idCardCopy', idcard_back: 'idCardNational' }
        Object.keys(singleMap).forEach((t) => {
          const list = byType[t]
          if (list && list.length) {
            const latest = list[list.length - 1]
            this.form[singleMap[t]] = latest.storageKey
            this.applyOcrResult(t, latest.ocrJson || {}, this.form, true, true)
          }
        })
        const multiMap = { entrance: 'storeEntrancePic', indoor: 'indoorPic', qualification: 'qualificationPics' }
        Object.keys(multiMap).forEach((t) => {
          const existing = this.form[multiMap[t]] || []
          const add = (byType[t] || []).map((img) => img.storageKey).filter((key) => existing.indexOf(key) === -1)
          if (add.length) {
            this.form[multiMap[t]] = existing.concat(add).slice(0, 5)
          }
        })
        this.normalizeArrays()
        this.syncFileList(this.form)
      }).catch(() => { /* 暂存图加载失败不阻断向导 */ })
    },
    // SVG 占位图（草稿/驳回恢复时本地无图片，仅提示已上传，可删除后重传）
    placeholderImage(text) {
      const svg = '<svg xmlns="http://www.w3.org/2000/svg" width="104" height="104">' +
        '<rect width="104" height="104" fill="#fafafa" stroke="#d9d9d9"/>' +
        '<text x="52" y="48" font-size="12" fill="#999" text-anchor="middle">已上传</text>' +
        '<text x="52" y="66" font-size="11" fill="#bbb" text-anchor="middle">' + text + '</text></svg>'
      return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg)
    },
    resetForm() {
      this.form = Object.assign({}, EMPTY_FORM, { uboList: [], qualificationPics: [] })
      this.fileList = { licenseCopy: [], idCardCopy: [], idCardNational: [], qualificationPics: [], storeEntrancePic: [], indoorPic: [] }
    },
    // ===== 向导步骤流转 =====
    validateStep(step) {
      const checks = STEP_CHECKS[step] || []
      for (let i = 0; i < checks.length; i++) {
        const val = this.form[checks[i][0]]
        if (val === undefined || val === null || ('' + val).trim() === '') {
          return checks[i][1]
        }
      }
      if (step === 4) {
        // 需资质行业：资质图片必填（与后端一致）；无需资质行业不校验、提交时也不携带
        if (this.industryNeedPics && !(this.form.qualificationPics || []).length) {
          return '所属行业需上传资质图片（' + this.industryHint + '），请补充'
        }
      }
      if (step === 5) {
        // 非直连银行（"其他银行"）必须选择支行全称；直连银行已自动以总行名填充
        if (!this.isDirectBank && !(this.form.bankName || '').trim()) {
          return '请选择开户行全称（从支行列表搜索选择）'
        }
      }
      if (step === 3) {
        // 经营者身份证精确校验（校验位 + 有效期格式），提前拦截减少微信驳回
        if (this.form.idCardNumber && !this.isValidIdCard(this.form.idCardNumber)) {
          return '经营者身份证号码校验位不正确，请核对'
        }
        const periodErr = this.checkPeriod(this.form.idCardPeriodBegin, this.form.idCardPeriodEnd, '经营者')
        if (periodErr) { return periodErr }
        // 企业主体：受益所有人逐人校验
        if (this.form.subjectType === '2500') {
          const ubos = this.form.uboList || []
          if (!ubos.length) {
            return '企业主体需至少填写1位受益所有人（法人100%持股可点"复用法人资料"）'
          }
          for (let i = 0; i < ubos.length; i++) {
            const u = ubos[i]
            const no = '第' + (i + 1) + '位受益所有人'
            if (!u.name || !u.name.trim()) { return no + '未填写姓名' }
            if (!u.idNumber || !u.idNumber.trim()) { return no + '未填写身份证号' }
            if (!this.isValidIdCard(u.idNumber)) { return no + '身份证号码校验位不正确，请核对' }
            if (!u.idCardCopy) { return no + '未上传身份证人像面' }
            if (!u.idCardNational) { return no + '未上传身份证国徽面' }
            const uboPeriodErr = this.checkPeriod(u.periodBegin, u.periodEnd, no)
            if (uboPeriodErr) { return uboPeriodErr }
          }
        }
      }
      return ''
    },
    // 18位身份证校验位算法（与后端一致）
    isValidIdCard(v) {
      const s = ('' + (v || '')).trim().toUpperCase()
      if (!/^\d{17}[\dX]$/.test(s)) { return false }
      const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
      const checkCodes = '10X98765432'
      let sum = 0
      for (let i = 0; i < 17; i++) {
        sum += Number(s.charAt(i)) * weights[i]
      }
      return checkCodes.charAt(sum % 11) === s.charAt(17)
    },
    // 有效期格式：起 YYYY-MM-DD；止 YYYY-MM-DD 或"长期"
    checkPeriod(begin, end, who) {
      const dateRe = /^\d{4}-\d{2}-\d{2}$/
      if (begin && !dateRe.test(('' + begin).trim())) {
        return who + '身份证有效期-起格式应为 YYYY-MM-DD（如 2020-01-01）'
      }
      if (end) {
        const e = ('' + end).trim()
        if (e !== '长期' && !dateRe.test(e)) {
          return who + '身份证有效期-止应为 YYYY-MM-DD 或"长期"'
        }
      }
      return ''
    },
    onStepChange(current) {
      const target = current + 1
      // 已到达过的步骤可点击切换（向导+标签式结合）
      if (target <= this.maxStep) {
        this.step = target
        if (target === 5) {
          this.prefillAccountName()
        }
      }
    },
    nextStep() {
      const err = this.validateStep(this.step)
      if (err) {
        this.$message.warning(err)
        return
      }
      this.saveDraft()
      if (this.step < 6) {
        this.step++
        this.maxStep = Math.max(this.maxStep, this.step)
        if (this.step === 5) {
          this.prefillAccountName()
        }
      }
    },
    // 线下场所省市区选择：末级（区县级）编码写入 bizAddressCode
    onBizAreaChange(path) {
      this.form.bizAddressCode = (path && path.length) ? path[path.length - 1] : ''
    },
    // 行业下拉本地过滤（按类目名包含匹配）
    filterIndustryOption(input, option) {
      const kw = (input || '').trim()
      if (!kw) return true
      const text = option.componentOptions.children[0].text || ''
      return text.indexOf(kw) > -1
    },
    // 开户名称智能预填（仅填空）：对公→商户名称，个人卡→经营者身份证姓名
    prefillAccountName() {
      if (this.form.accountName) {
        return
      }
      if (this.form.subjectType === '2500') {
        this.form.accountName = this.form.mchName || ''
      } else {
        this.form.accountName = this.form.idCardName || this.form.licenseLegalPerson || ''
      }
    },
    prevStep() {
      if (this.step > 1) {
        this.step--
      }
    },
    // ===== 图片上传（客户端 canvas 自动压缩 + 自动 OCR） =====
    beforeUpload(file) {
      const name = (file.name || '').toLowerCase()
      if (!(name.endsWith('.jpg') || name.endsWith('.jpeg') || name.endsWith('.bmp') || name.endsWith('.png'))) {
        this.$message.warning('仅支持 jpg/bmp/png 格式图片')
        return false
      }
      return true
    },
    // >2MB 自动压缩：先按最长边 1600 缩放，quality 0.8→0.6→0.4 递减，直至 ≤2MB
    compressImage(file) {
      const MAX = 2 * 1024 * 1024
      if (file.size <= MAX) {
        return Promise.resolve(file)
      }
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (e) => {
          const img = new Image()
          img.onload = () => {
            const maxSide = 1600
            let w = img.width
            let h = img.height
            if (Math.max(w, h) > maxSide) {
              const scale = maxSide / Math.max(w, h)
              w = Math.max(1, Math.round(w * scale))
              h = Math.max(1, Math.round(h * scale))
            }
            const canvas = document.createElement('canvas')
            canvas.width = w
            canvas.height = h
            const ctx = canvas.getContext('2d')
            ctx.fillStyle = '#fff'
            ctx.fillRect(0, 0, w, h)
            ctx.drawImage(img, 0, 0, w, h)
            let blob = null
            const qualities = [0.8, 0.6, 0.4]
            for (let i = 0; i < qualities.length; i++) {
              blob = this.dataUrlToBlob(canvas.toDataURL('image/jpeg', qualities[i]))
              if (blob.size <= MAX) break
            }
            resolve(blob)
          }
          img.onerror = () => reject(new Error('图片解析失败'))
          img.src = e.target.result
        }
        reader.onerror = () => reject(new Error('图片读取失败'))
        reader.readAsDataURL(file)
      })
    },
    dataUrlToBlob(dataUrl) {
      const parts = dataUrl.split(',')
      const mime = (parts[0].match(/:(.*?);/) || [])[1] || 'image/jpeg'
      const raw = atob(parts[1])
      const arr = new Uint8Array(raw.length)
      for (let i = 0; i < raw.length; i++) {
        arr[i] = raw.charCodeAt(i)
      }
      return new Blob([arr], { type: mime })
    },
    doUpload({ file, onSuccess, onError }, field) {
      // 先置 uploading 状态（缩略图区域显示加载中），成功后换成真实缩略图
      this.fileList[field] = [{ uid: field + '_uploading', name: file.name || '照片', status: 'uploading' }]
      this.compressImage(file).then((blob) => {
        const thumbUrl = URL.createObjectURL(blob)
        const formData = new FormData()
        formData.append('file', blob, (file.name || 'upload').replace(/\.\w+$/, '') + '.jpg')
        formData.append('type', UPLOAD_TYPE[field])
        return uploadMchApplyImage(formData).then((res) => ({ res: res, thumbUrl: thumbUrl }))
      }).then(({ res, thumbUrl }) => {
        if (res.code === 200 && res.data && res.data.storageKey) {
          const storageKey = res.data.storageKey
          this.form[field] = storageKey
          this.fileList[field] = [{ uid: field, name: file.name, status: 'done', thumbUrl: thumbUrl, mediaId: storageKey }]
          onSuccess && onSuccess(res, file)
          // 上传响应已含 OCR 识别结果，直接回填（无需再单独调识别接口）
          this.applyOcrResult(UPLOAD_TYPE[field], res.data, this.form)
        } else {
          this.fileList[field] = []
          this.$message.warning(res.message || '图片上传失败')
          onError && onError(new Error(res.message || 'upload failed'))
        }
      }).catch((err) => {
        this.fileList[field] = []
        this.$message.warning('图片上传失败：' + (err.message || err))
        onError && onError(err)
      })
    },
    // 大图预览（点击缩略图）：占位图时按需加载本地副本真实图，加载成功后再打开
    handlePreview(file) {
      if (!file) return
      const openPreview = (url) => {
        this.previewImage = url
        if (this.previewImage) {
          this.previewVisible = true
        }
      }
      const isPlaceholder = (file.thumbUrl || '').indexOf('data:image/svg') === 0
      if (isPlaceholder && file.mediaId) {
        const hide = this.$message.loading('图片加载中...', 0)
        getMchApplyImage(file.mediaId).then((resp) => {
          if (resp && resp.size > 0) {
            file.thumbUrl = URL.createObjectURL(resp)
            openPreview(file.thumbUrl)
          } else {
            this.$message.warning('图片加载失败')
          }
        }).catch(() => {
          this.$message.warning('图片加载失败，请删除后重新上传')
        }).then(() => { hide() })
      } else {
        openPreview(file.thumbUrl || file.url || '')
      }
    },
    // 删除已上传图片（清空表单引用并删除服务器暂存，允许重新上传）
    handleRemove(file, field) {
      const old = (this.fileList[field] || [])[0]
      if (old && old.thumbUrl && old.thumbUrl.indexOf('blob:') === 0) {
        URL.revokeObjectURL(old.thumbUrl)
      }
      this.removeStagedImage(this.form[field])
      this.form[field] = ''
      this.fileList[field] = []
    },
    // OCR 独立识别（仅银行卡使用，识别结果回填不产生图片；其余类型识别结果已随上传返回）
    runOcr(cardType, blob, target) {
      const formData = new FormData()
      formData.append('file', blob, 'ocr.jpg')
      ocrMchApply(cardType, formData).then((res) => {
        if (res.code === 200 && res.data) {
          this.applyOcrResult(cardType, res.data, target)
        } else {
          this.$message.info((res && res.message) || 'OCR识别失败，请手动填写')
        }
      }).catch(() => {
        this.$message.info('OCR识别失败，请手动填写')
      })
    },
    // 应用识别结果回填（data=识别字段映射；target 传入受益所有人对象时回填到该对象）
    // onlyEmpty=true 仅填空字段（暂存图回显时用，不覆盖已填值）；silent=true 不弹提示
    applyOcrResult(cardType, data, target, onlyEmpty, silent) {
      if (!data) { return }
      const dst = target || this.form
      const filledFields = []
      const put = (obj, field, value) => {
        if (!value) { return }
        if (onlyEmpty && obj[field]) { return }
        obj[field] = value
      }
      if (target) {
        // 受益所有人字段名与主表单不同，按 [OCR字段, 受益人字段] 映射回填
        ;(UBO_OCR_MAP[cardType] || []).forEach(([srcField, dstField]) => {
          const before = dst[dstField]
          put(dst, dstField, data[srcField])
          if (dst[dstField] !== before && !before) { filledFields.push(UBO_FIELD_LABELS[dstField] || dstField) }
        })
        if (!silent) {
          if (!filledFields.length) {
            this.$message.info('未识别到有效内容，请手动填写')
          } else {
            this.$message.success('已自动识别填写：' + filledFields.join('、') + '，请核对')
          }
        }
        return
      }
      ;(OCR_FIELDS[cardType] || []).forEach((field) => {
        const before = dst[field]
        put(dst, field, data[field])
        if (dst[field] !== before && !before) { filledFields.push(FIELD_LABELS[field] || field) }
      })
      // 执照/身份证识别后预填联系人（仅填空，可修改）
      if (!this.form.contactName) {
        const contact = cardType === 'license' ? this.form.licenseLegalPerson : this.form.idCardName
        if (contact) {
          this.form.contactName = contact
          filledFields.push(FIELD_LABELS.contactName)
        }
      }
      // 执照"类型"自动识别主体类型（含"个体"→个体工商户，否则→企业；识别不到不改动，仍可手动修改）
      if (cardType === 'license' && data.licenseType && !onlyEmpty) {
        const detected = data.licenseType.indexOf('个体') > -1 ? '4' : '2500'
        if (this.form.subjectType !== detected) {
          this.form.subjectType = detected
          this.handleSubjectChange(detected)
        }
        this.$message.info('已自动识别主体类型：' + SUBJECT_TEXT[detected] + '，如不符可手动修改')
      }
      // 银行卡识别的总行名匹配微信官方列表（如"中国工商银行"→"工商银行"，直连银行免填支行）
      if (cardType === 'bankcard' && dst.accountBank) {
        const matched = this.matchWxBank(dst.accountBank)
        if (matched) {
          dst.accountBank = matched
          dst.bankName = matched
        } else {
          dst.accountBank = '其他银行'
        }
      }
      if (!silent) {
        if (filledFields.length > 0) {
          this.$message.success('已自动识别填写：' + filledFields.join('、') + '，请核对')
        } else {
          this.$message.info('未识别到有效内容，请手动填写')
        }
      }
    },
    // 银行卡拍照识别（仅 OCR 回填，不产生 mediaId）
    onBankCardOcr({ file, onSuccess, onError }) {
      this.compressImage(file).then((blob) => {
        this.runOcr('bankcard', blob)
        onSuccess && onSuccess({}, file)
      }).catch((err) => {
        this.$message.warning('图片处理失败：' + (err.message || err))
        onError && onError(err)
      })
    },
    // 切换开户银行：直连银行自动以总行名作为开户行全称；其他银行清空待选支行
    onBankChange(val) {
      this.branchOptions = []
      if (WX_DIRECT_BANKS.indexOf((val || '').trim()) > -1) {
        this.form.bankName = (val || '').trim()
      } else {
        this.form.bankName = ''
      }
    },
    // 银行下拉本地过滤（按拼音首字/包含均可，antd 需显式开启）
    filterBankOption(input, option) {
      const kw = (input || '').trim()
      if (!kw) return true
      const text = option.componentOptions.children[0].text || ''
      return text.indexOf(kw) > -1
    },
    // OCR/档案中的银行名匹配微信直连列表（"中国工商银行"→"工商银行"；匹配不到返回原值）
    matchWxBank(name) {
      const n = (name || '').replace(/\s/g, '')
      if (!n) return ''
      const hit = WX_DIRECT_BANKS.find((b) => n.indexOf(b) > -1 || b.indexOf(n) > -1)
      return hit || ''
    },
    // 支行远程模糊搜索（联行号库，输入≥2字触发，300ms 防抖；"其他银行"不做总行过滤）
    onBranchSearch(value) {
      if (this.branchTimer) { clearTimeout(this.branchTimer) }
      const kw = (value || '').trim()
      if (kw.length < 2) { this.branchOptions = []; return }
      this.branchTimer = setTimeout(() => {
        this.branchSearching = true
        getMchApplyBankBranches({
          keyword: kw, limit: 20,
          accountBank: '',
          addressCode: (this.form.bankAddressCode || '').trim()
        }).then((res) => {
          if (res.code === 200) {
            this.branchOptions = (res.data || []).map((r) => ({
              value: r.bankFullName,
              label: r.bankFullName + '（' + (r.cityName || '') + '）',
              row: r
            }))
          }
        }).finally(() => { this.branchSearching = false })
      }, 300)
    },
    // 选中支行：自动回填开户银行与省市编码
    onBranchSelect(value) {
      const opt = this.branchOptions.find((o) => o.value === value)
      if (opt && opt.row) {
        // account_bank 保持"其他银行"，仅回填省市编码（支行全称已由选择器写入 bankName）
        this.form.bankAddressCode = opt.row.bankAddressCode || this.form.bankAddressCode
        this.$message.success('已自动填写开户行省市编码')
      }
    },
    handleSubjectChange(val) {
      if (val === '2500') {
        this.form.bankAccountType = 'CORPORATE'
        this.ensureUboRow()
      } else if (val === '4') {
        // 个体户默认经营者个人卡（多数个体户无对公户，可手动改对公）
        this.form.bankAccountType = 'PERSONAL'
      }
      this.syncAccountName()
    },
    // 账户类型切换：开户名按规则联动
    onAccountTypeChange() {
      this.syncAccountName()
    },
    // 开户名按微信规则联动：对公=执照商户名称，个人卡=经营者姓名（后端同规则强校验，预期值为空时不动）
    syncAccountName() {
      const expect = this.form.bankAccountType === 'CORPORATE'
        ? (this.form.mchName || '').trim()
        : (this.form.licenseLegalPerson || '').trim()
      if (expect) {
        this.form.accountName = expect
      }
    },
    // 省市选择：末级编码写入 bankAddressCode（直辖市即省级码）
    onAreaChange(path) {
      this.form.bankAddressCode = (path && path.length) ? path[path.length - 1] : ''
    },
    // ===== 受益所有人（企业主体必填） =====
    newUbo() {
      return { name: '', idNumber: '', idCardCopy: '', idCardNational: '', periodBegin: '', periodEnd: '', flCopy: [], flNational: [] }
    },
    // 企业主体且无受益人时自动补一行空卡片
    ensureUboRow() {
      if (this.form.subjectType === '2500' && (!this.form.uboList || this.form.uboList.length === 0)) {
        if (!Array.isArray(this.form.uboList)) { this.form.uboList = [] }
        this.form.uboList.push(this.newUbo())
      }
    },
    addUbo() {
      this.form.uboList.push(this.newUbo())
    },
    removeUbo(idx) {
      // 释放缩略图 objectURL，避免内存泄漏
      const u = this.form.uboList[idx]
      ;['flCopy', 'flNational'].forEach((k) => {
        (u[k] || []).forEach((f) => {
          if (f.thumbUrl && f.thumbUrl.indexOf('blob:') === 0) { URL.revokeObjectURL(f.thumbUrl) }
        })
      })
      this.form.uboList.splice(idx, 1)
    },
    // 法人100%持股：一键复用经营者/法人身份证资料
    copyLegalAsUbo() {
      if (!this.form.idCardCopy || !this.form.idCardNational) {
        this.$message.warning('请先在上方上传经营者/法人身份证两面照片，再复用')
        return
      }
      const u = this.newUbo()
      u.name = this.form.idCardName || this.form.licenseLegalPerson || ''
      u.idNumber = this.form.idCardNumber || ''
      u.idCardCopy = this.form.idCardCopy
      u.idCardNational = this.form.idCardNational
      u.periodBegin = this.form.idCardPeriodBegin || ''
      u.periodEnd = this.form.idCardPeriodEnd || ''
      u.flCopy = [{ uid: 'ubo_copy', name: '身份证人像面', status: 'done', thumbUrl: this.placeholderImage('法人证件') }]
      u.flNational = [{ uid: 'ubo_national', name: '身份证国徽面', status: 'done', thumbUrl: this.placeholderImage('法人证件') }]
      const first = this.form.uboList[0]
      if (this.form.uboList.length === 1 && first && !first.name && !first.idCardCopy && !first.idNumber) {
        this.form.uboList.splice(0, 1, u) // 替换空白行
      } else {
        this.form.uboList.push(u)
      }
      this.$message.success('已复用经营者/法人身份证资料，请核对后提交')
    },
    // 受益所有人证件上传（成功后用响应内 OCR 结果回填到该受益人）
    doUploadUbo({ file, onSuccess, onError }, ubo, field) {
      const flKey = field === 'idCardCopy' ? 'flCopy' : 'flNational'
      const ocrType = field === 'idCardCopy' ? 'idcard_front' : 'idcard_back'
      ubo[flKey] = [{ uid: field + '_uploading', name: file.name || '照片', status: 'uploading' }]
      this.compressImage(file).then((blob) => {
        const thumbUrl = URL.createObjectURL(blob)
        const formData = new FormData()
        formData.append('file', blob, (file.name || 'upload').replace(/\.\w+$/, '') + '.jpg')
        formData.append('type', UBO_UPLOAD_TYPE[field])
        return uploadMchApplyImage(formData).then((res) => ({ res: res, thumbUrl: thumbUrl }))
      }).then(({ res, thumbUrl }) => {
        if (res.code === 200 && res.data && res.data.storageKey) {
          ubo[field] = res.data.storageKey
          ubo[flKey] = [{ uid: field, name: file.name, status: 'done', thumbUrl: thumbUrl, mediaId: res.data.storageKey }]
          onSuccess && onSuccess(res, file)
          this.applyOcrResult(ocrType, res.data, ubo)
        } else {
          ubo[flKey] = []
          this.$message.warning(res.message || '图片上传失败')
          onError && onError(new Error('upload failed'))
        }
      }).catch((err) => {
        ubo[flKey] = []
        this.$message.warning('图片上传失败：' + (err.message || err))
        onError && onError(err)
      })
    },
    handleRemoveUbo(ubo, field) {
      const flKey = field === 'idCardCopy' ? 'flCopy' : 'flNational'
      const old = (ubo[flKey] || [])[0]
      if (old && old.thumbUrl && old.thumbUrl.indexOf('blob:') === 0) {
        URL.revokeObjectURL(old.thumbUrl)
      }
      this.removeStagedImage(ubo[field])
      ubo[field] = ''
      ubo[flKey] = []
    },
    // 切换所属行业：资质与行业绑定，清空已传资质图（防旧资质不适配新行业）
    onIndustryChange() {
      (this.fileList.qualificationPics || []).forEach((f) => {
        if (f.thumbUrl && f.thumbUrl.indexOf('blob:') === 0) { URL.revokeObjectURL(f.thumbUrl) }
      })
      this.fileList.qualificationPics = []
      this.form.qualificationPics = []
    },
    // ===== 多图上传（门头照/内部照/行业资质，各≤5张） =====
    doUploadMulti({ file, onSuccess, onError }, field) {
      if (this.form[field].length >= 5) {
        this.$message.warning('图片最多5张')
        onError && onError(new Error('limit'))
        return
      }
      this.compressImage(file).then((blob) => {
        const thumbUrl = URL.createObjectURL(blob)
        const formData = new FormData()
        formData.append('file', blob, (file.name || 'upload').replace(/\.\w+$/, '') + '.jpg')
        formData.append('type', UPLOAD_TYPE[field])
        return uploadMchApplyImage(formData).then((res) => ({ res: res, thumbUrl: thumbUrl }))
      }).then(({ res, thumbUrl }) => {
        if (res.code === 200 && res.data && res.data.storageKey) {
          this.form[field].push(res.data.storageKey)
          this.fileList[field].push({ uid: res.data.storageKey, name: file.name, status: 'done', thumbUrl: thumbUrl, mediaId: res.data.storageKey })
          onSuccess && onSuccess(res, file)
        } else {
          this.$message.warning(res.message || '图片上传失败')
          onError && onError(new Error('upload failed'))
        }
      }).catch((err) => {
        this.$message.warning('图片上传失败：' + (err.message || err))
        onError && onError(err)
      })
    },
    removeMulti(file, field) {
      const uid = '' + (file.uid || '')
      // 占位项 uid 为 ph_<key>，上传项 uid 即 storageKey
      const key = uid.indexOf('ph_') === 0 ? uid.slice(3) : uid
      const i = this.form[field].indexOf(key)
      if (i > -1) { this.form[field].splice(i, 1) }
      const j = this.fileList[field].findIndex((f) => '' + f.uid === uid)
      if (j > -1) {
        const item = this.fileList[field][j]
        if (item.thumbUrl && item.thumbUrl.indexOf('blob:') === 0) { URL.revokeObjectURL(item.thumbUrl) }
        this.fileList[field].splice(j, 1)
      }
      this.removeStagedImage(key)
    },
    // 删除服务器暂存图片（storageKey 格式才调接口；旧微信 mediaId 无暂存记录，跳过）
    removeStagedImage(key) {
      if (key && /^\d+\//.test(key)) {
        deleteMchApplyImage(key).catch(() => { /* 删除失败不阻断界面操作 */ })
      }
    },
    openSignUrl() {
      if (this.statusInfo.signUrl) {
        window.open(this.statusInfo.signUrl, '_blank')
      }
    },
    // 拉取签约/账户验证二维码（待验证/待签约且有 signUrl 时；失败静默）
    loadSignQr(data) {
      this.signQr = ''
      if ((data.applyStatus === '1' || data.applyStatus === '2') && data.signUrl) {
        getMchApplySignQrcode().then((qr) => {
          if (qr.code === 200 && qr.data && qr.data.qrcodeBase64) {
            this.signQr = qr.data.qrcodeBase64
          }
        }).catch(() => { /* 二维码加载失败不阻断，仍可打开链接 */ })
      }
    },
    // 支付宝授权二维码加载 + 授权结果轮询（仅待授权状态；已授权/未开通时停止轮询）
    syncAliQr() {
      if (this.aliInfo.applyStatus !== '0') {
        this.aliQr = ''
        if (this.aliPollTimer) {
          clearInterval(this.aliPollTimer)
          this.aliPollTimer = null
        }
        return
      }
      if (!this.aliQr) {
        getMchApplySignQrcode('ALI').then((qr) => {
          if (qr.code === 200 && qr.data && qr.data.qrcodeBase64 && this.aliInfo.applyStatus === '0') {
            this.aliQr = qr.data.qrcodeBase64
          }
        }).catch(() => { /* 二维码加载失败不阻断，可点重新发起 */ })
      }
      if (!this.aliPollTimer) {
        this.aliPollTimer = setInterval(() => this.pollStatus(), 5000)
      }
    },
    // 轮询刷新渠道状态（不触碰表单/草稿；服务端发现已授权会自动回填开通）
    pollStatus() {
      getMchApplyCurrent().then((res) => {
        if (res.code === 200) {
          const data = res.data || {}
          this.statusInfo = data.wx || {}
          this.aliInfo = data.ali || {}
          this.loadSignQr(this.statusInfo)
          this.syncAliQr()
          // 当面付签约状态机（不回显表单，避免覆盖用户输入）
          this.syncFaceState()
        }
      }).catch(() => { /* 轮询失败静默，下轮重试 */ })
    },
    // 浏览器打开支付宝授权页（支付宝App扫二维码不回跳回调，须在浏览器中完成授权）
    openAliAuth() {
      if (!this.aliInfo.signUrl) {
        this.$message.warning('暂无授权链接，请先发起授权')
        return
      }
      window.open(this.aliInfo.signUrl, '_blank')
    },
    // 发起支付宝授权（零资料）：复用已填商户资料，成功后展示授权二维码
    startAliAuth() {
      this.aliStarting = true
      const payload = {
        channels: ['ALI'],
        mchName: this.form.mchName,
        mchShortName: this.form.mchShortName,
        subjectType: this.form.subjectType,
        contactName: this.form.contactName,
        contactMobile: this.form.contactMobile
      }
      submitMchApply(payload).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message || '授权已发起，请用收款的支付宝扫码完成授权')
          this.aliQr = ''
          this.load()
        } else {
          this.$message.warning(res.message || '发起授权失败，请稍后重试')
        }
      }).finally(() => {
        this.aliStarting = false
      })
    },
    // ===== 支付宝当面付代签约（已授权商户补签产品，四态状态机） =====
    // 回显已保存的签约资料（仅 load 时调用，轮询不覆盖用户输入）
    initFaceForm() {
      const info = this.aliInfo || {}
      const province = info.shopProvinceCode || ''
      const city = info.shopCityCode || ''
      const district = info.shopDistrictCode || ''
      this.faceForm = {
        mccCode: info.aliMccCode || undefined,
        areaPath: province && city && district ? [province, city, district] : [],
        detailAddress: info.shopDetailAddress || '',
        aliAccount: ''
      }
    },
    // 当面付状态机：审核中/待商家确认需轮询，待确认展示确认二维码，终态停止轮询
    syncFaceState() {
      const st = '' + (this.aliInfo.faceStatus || '0')
      if (st === '1' || st === '2') {
        if (st === '2') {
          if (!this.aliFaceQr) this.loadFaceQr()
        } else {
          this.aliFaceQr = ''
        }
        this.startFacePoll()
      } else {
        this.aliFaceQr = ''
        this.stopFacePoll()
      }
    },
    // 拉取当面付商家确认二维码（后端待确认态返回 face_confirm_url 的二维码）
    loadFaceQr() {
      getMchApplySignQrcode('ALI').then((qr) => {
        if (qr.code === 200 && qr.data && qr.data.qrcodeBase64 && ('' + (this.aliInfo.faceStatus || '0')) === '2') {
          this.aliFaceQr = qr.data.qrcodeBase64
        }
      }).catch(() => { /* 二维码加载失败不阻断，可复制链接发给商家 */ })
    },
    // 复制商家确认链接（发给商家在支付宝App中打开确认开通）
    openAliFaceConfirm() {
      const url = this.aliInfo.faceConfirmUrl
      if (!url) {
        this.$message.warning('暂无确认链接，请稍后刷新重试')
        return
      }
      const input = document.createElement('textarea')
      input.value = url
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('确认链接已复制，请发给商家在支付宝App中打开')
    },
    startFacePoll() {
      if (this.facePollTimer) return
      this.facePollTimer = setInterval(() => this.pollFaceStatus(), 10000)
    },
    stopFacePoll() {
      if (this.facePollTimer) {
        clearInterval(this.facePollTimer)
        this.facePollTimer = null
      }
    },
    // 轮询当面付签约结果（静默；状态或确认链接变化时刷新展示）
    pollFaceStatus() {
      getAliFaceStatus().then((res) => {
        if (res.code !== 200 || !res.data) return
        const st = '' + (res.data.faceStatus || '0')
        const confirmUrl = res.data.confirmUrl || ''
        if (st !== ('' + (this.aliInfo.faceStatus || '0')) || confirmUrl !== (this.aliInfo.faceConfirmUrl || '')) {
          this.aliInfo = Object.assign({}, this.aliInfo, {
            faceStatus: st, faceConfirmUrl: confirmUrl, faceRejectReason: res.data.rejectReason || ''
          })
          // 驳回/作废回到表单态：回显上次提交资料便于修改重提
          if (st === '4' || st === '0') {
            this.initFaceForm()
          }
          this.syncFaceState()
          if (st === '3') {
            this.$message.success('当面付已开通，支付宝收款已生效')
          }
        }
      }).catch(() => { /* 轮询失败静默，下轮重试 */ })
    },
    // 提交当面付签约（类目必填；地址选填，留空自动复用微信进件的线下场所地址）
    submitAliFaceSign() {
      if (!this.faceForm.mccCode) {
        this.$message.warning('请选择经营类目')
        return
      }
      const areaPath = this.faceForm.areaPath || []
      const detail = (this.faceForm.detailAddress || '').trim()
      if (areaPath.length > 0 && areaPath.length < 3) {
        this.$message.warning('请选全省/市/区，或清空后自动复用微信进件的店铺地址')
        return
      }
      if (areaPath.length === 3 && !detail) {
        this.$message.warning('已选择店铺地区，请填写详细地址；或清空地区自动复用微信进件的店铺地址')
        return
      }
      const payload = { mccCode: this.faceForm.mccCode }
      const account = (this.faceForm.aliAccount || '').trim()
      if (account) payload.aliAccount = account
      const licenseMobile = (this.faceForm.licenseMobile || '').trim()
      if (licenseMobile) payload.licenseMobile = licenseMobile
      // 地址四参数与后端约定：全传或全不传（不传时后端从微信进件资料自动兜底）
      if (areaPath.length === 3) {
        payload.provinceCode = areaPath[0]
        payload.cityCode = areaPath[1]
        payload.districtCode = areaPath[2]
        payload.detailAddress = detail
      }
      this.faceSubmitting = true
      submitAliFaceSignApi(payload).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message || '签约申请已提交，等待支付宝审核')
          this.load()
        } else {
          // 失败原因（如类目资质不符）较长，用通知完整展示
          this.$notification.error({ message: '当面付签约提交失败', description: res.message || '请稍后重试', duration: 0 })
        }
      }).finally(() => {
        this.faceSubmitting = false
      })
    },
    handleSubmit() {
      // 渠道勾选：至少选一个；仅支付宝时跳过微信资料校验（授权制零资料）
      const hasWx = this.channels.indexOf('WX') > -1
      const hasAli = this.channels.indexOf('ALI') > -1
      if (!hasWx && !hasAli) {
        this.$message.warning('请至少选择一个收款渠道')
        return
      }
      if (hasWx) {
        // 步骤1-5 全量校验兜底
        for (let s = 1; s <= 5; s++) {
          const err = this.validateStep(s)
          if (err) {
            this.step = s
            this.maxStep = Math.max(this.maxStep, s)
            this.$message.warning(err)
            return
          }
        }
      }
      this.submitting = true
      // 组装提交数据：剔除界面辅助字段（flCopy/flNational），个体户不带受益所有人；渠道随勾选
      const payload = hasWx ? Object.assign({}, this.form) : {
        mchName: this.form.mchName, mchShortName: this.form.mchShortName,
        subjectType: this.form.subjectType, contactName: this.form.contactName,
        contactMobile: this.form.contactMobile
      }
      payload.channels = this.channels.slice()
      // 直连银行：开户行全称以总行名提交（微信规则：直连银行无需支行信息）
      if (this.isDirectBank) {
        payload.bankName = (this.form.accountBank || '').trim()
      }
      payload.uboList = this.form.subjectType === '2500'
        ? this.form.uboList.map((u) => ({
          name: u.name, idNumber: u.idNumber, idCardCopy: u.idCardCopy,
          idCardNational: u.idCardNational, periodBegin: u.periodBegin, periodEnd: u.periodEnd
        }))
        : []
      // 无需资质行业不携带资质图（与后端过滤一致，双保险）
      payload.qualificationPics = this.industryNeedPics ? (this.form.qualificationPics || []).slice(0, 5) : []
      payload.storeEntrancePic = (this.form.storeEntrancePic || []).slice(0, 5)
      payload.indoorPic = (this.form.indoorPic || []).slice(0, 5)
      submitMchApply(payload).then((res) => {
        if (res.code === 200) {
          if (hasWx) {
            this.clearDraft()
          }
          this.$message.success(res.message || '已提交，可稍后刷新进度')
          this.load()
        } else {
          // 失败原因较长，message 单行会截断，用通知完整展示
          this.$notification.error({ message: '提交失败', description: res.message || '请稍后重试', duration: 0 })
        }
      }).finally(() => {
        this.submitting = false
      })
    },
    // ===== 支付宝渠道：商户信息手动回填（运营平台手动添加商户/应用后填入） =====
    startEditAli() {
      this.aliMchNo = this.aliInfo.jeepayMchNo || ''
      this.aliAppId = this.aliInfo.jeepayAppId || ''
      this.aliAppSecret = this.aliInfo.jeepayAppSecret || ''
      this.aliEditing = true
    },
    saveAliMerchant() {
      const mchNo = (this.aliMchNo || '').trim()
      if (!/^[A-Za-z0-9]{6,64}$/.test(mchNo)) {
        this.$message.warning('请输入正确的商户号（6-64位字母或数字，由平台运营提供）')
        return
      }
      const appId = (this.aliAppId || '').trim()
      const appSecret = (this.aliAppSecret || '').trim()
      if ((appId && !/^[A-Za-z0-9]{6,128}$/.test(appId)) || (appSecret && !/^[A-Za-z0-9]{6,128}$/.test(appSecret))) {
        this.$message.warning('应用ID/应用密钥格式为6-128位字母或数字（由平台运营提供），可留空')
        return
      }
      this.aliSaving = true
      saveMchApplyAliMerchant({ mchNo: mchNo, appId: appId, appSecret: appSecret }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message || '支付宝商户信息已保存')
          this.aliEditing = false
          this.load()
        } else {
          this.$message.warning(res.message || '保存失败，请稍后重试')
        }
      }).finally(() => {
        this.aliSaving = false
      })
    },
    handleClose() {
      // 释放缩略图 objectURL，避免内存泄漏
      Object.keys(this.fileList).forEach((field) => {
        (this.fileList[field] || []).forEach((item) => {
          if (item && item.thumbUrl && item.thumbUrl.indexOf('blob:') === 0) {
            URL.revokeObjectURL(item.thumbUrl)
          }
        })
      })
      ;(this.form.uboList || []).forEach((u) => {
        ;['flCopy', 'flNational'].forEach((k) => {
          (u[k] || []).forEach((f) => {
            if (f.thumbUrl && f.thumbUrl.indexOf('blob:') === 0) { URL.revokeObjectURL(f.thumbUrl) }
          })
        })
      })
      this.previewVisible = false
      this.previewImage = ''
      this.aliEditing = false
      this.aliMchNo = ''
      this.aliAppId = ''
      this.aliAppSecret = ''
      this.aliQr = ''
      this.channels = ['WX', 'ALI']
      if (this.aliPollTimer) {
        clearInterval(this.aliPollTimer)
        this.aliPollTimer = null
      }
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>
<style scoped>
.channel-cards { margin-bottom: 8px; }
.status-alert { margin-bottom: 8px; }
.sign-qr { display: block; width: 200px; height: 200px; margin: 8px 0; border: 1px solid #e8e8e8; }
.tip-text { color: #999; font-size: 12px; margin-top: 4px; }
.reject-remark { margin-top: 8px; color: #f5222d; }
.wizard-steps { margin: 4px 0 20px; }
.ocr-tip { margin-bottom: 12px; }
.apply-uploader >>> .ant-upload-select-picture-card i { font-size: 24px; color: #999; }
.apply-uploader >>> .ant-upload-select-picture-card .ant-upload-text { margin-top: 4px; color: #666; }
.summary-box { border: 1px solid #e8e8e8; border-radius: 4px; padding: 12px 16px; }
.summary-row { display: flex; line-height: 30px; font-size: 13px; }
.summary-label { color: #888; width: 150px; flex-shrink: 0; }
.summary-value { color: #333; flex: 1; word-break: break-all; }
.ubo-card { border: 1px solid #e8e8e8; border-radius: 4px; padding: 12px 16px 4px; margin-bottom: 12px; background: #fafafa; }
.ubo-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; font-weight: 500; }
</style>
